export const categoryListData = [
  {
    id: 659,
    name: "MODEL GALLERY",
    category_image: "",
    primary_media:
      "https://d2l284xife67k4.cloudfront.net/placeholder-images/1-building/Axon-Still.png",
    secondary_media: null,
    second_image: "no",
    parent_category: null,
    hardware_id: 43,
    instance_player: null,
    secondary_player: "43",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    primary_type: "image",
    primary_media_id: 581,
    primary_loop: "no",
    get_primary_media: {
      id: 581,
      folder_id: 55,
      media_name: "Axon Still.png",
      media_url: "Axon-Still.png",
      media_type: "image",
      status: "active",
      created_at: "2024-06-11 02:39:09",
      updated_at: "2024-06-11 02:39:09",
    },
    get_exit_players: [],
  },
  {
    id: 660,
    name: "AMENITIES DISPLAY",
    category_image: "",
    primary_media:
      "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/Pool.jpeg",
    secondary_media: null,
    second_image: "no",
    parent_category: null,
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    primary_type: "image",
    primary_media_id: 579,
    primary_loop: "no",
    get_primary_media: {
      id: 579,
      folder_id: 56,
      media_name: "Pool.jpeg",
      media_url: "Pool.jpeg",
      media_type: "image",
      status: "active",
      created_at: "2024-06-11 02:09:04",
      updated_at: "2024-06-11 02:09:04",
    },
    get_exit_players: [],
  },
  {
    id: 661,
    name: "AMENITIES MODEL",
    category_image: "",
    primary_media:
      "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/Library-Stairs.jpeg",
    secondary_media: null,
    second_image: "no",
    parent_category: null,
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    primary_type: "image",
    primary_media_id: 518,
    primary_loop: "no",
    get_primary_media: {
      id: 518,
      folder_id: 51,
      media_name: "Library Stairs.jpeg",
      media_url: "Library-Stairs.jpeg",
      media_type: "image",
      status: "active",
      created_at: "2024-06-11 01:42:42",
      updated_at: "2024-06-11 01:42:42",
    },
    get_exit_players: [],
  },
  {
    id: 662,
    name: "GREAT ROOM",
    category_image: "",
    primary_media:
      "https://d2l284xife67k4.cloudfront.net/placeholder-images/4-great-room/Hero.jpeg",
    secondary_media: null,
    second_image: "no",
    parent_category: null,
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    primary_type: "image",
    primary_media_id: 580,
    primary_loop: "no",
    get_primary_media: {
      id: 580,
      folder_id: 65,
      media_name: "Hero.jpeg",
      media_url: "Hero.jpeg",
      media_type: "image",
      status: "active",
      created_at: "2024-06-11 02:17:06",
      updated_at: "2024-06-11 02:17:06",
    },
    get_exit_players: [],
  },
  {
    id: 663,
    name: "LOUNGE ROOM",
    category_image: "",
    primary_media:
      "https://d2l284xife67k4.cloudfront.net/placeholder-images/4-great-room/Hero.jpeg",
    secondary_media: null,
    second_image: "no",
    parent_category: null,
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    primary_type: "image",
    primary_media_id: 580,
    primary_loop: "no",
    get_primary_media: {
      id: 580,
      folder_id: 65,
      media_name: "Hero.jpeg",
      media_url: "Hero.jpeg",
      media_type: "image",
      status: "active",
      created_at: "2024-06-11 02:17:06",
      updated_at: "2024-06-11 02:17:06",
    },
    get_exit_players: [],
  },
  {
    id: 741,
    name: "MEETING ROOM",
    category_image: "",
    primary_media:
      "https://d2l284xife67k4.cloudfront.net/placeholder-images/4-great-room/Hero.jpeg",
    secondary_media: null,
    second_image: "no",
    parent_category: null,
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "no",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    primary_type: "image",
    primary_media_id: 580,
    primary_loop: "no",
    get_primary_media: {
      id: 580,
      folder_id: 65,
      media_name: "Hero.jpeg",
      media_url: "Hero.jpeg",
      media_type: "image",
      status: "active",
      created_at: "2024-06-11 02:17:06",
      updated_at: "2024-06-11 02:17:06",
    },
    get_exit_players: [],
  },
];

export const categoryDetails = [
  {
    id: 665,
    name: "BUILDING",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 659,
      name: "MODEL GALLERY",
      category_image: "",
      primary_media: 581,
      secondary_media: null,
      second_image: "no",
      parent_category: null,
      hardware_id: 43,
      instance_player: "",
      secondary_player: 43,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [
      {
        id: 677,
        name: "FULL",
        parent_category: 665,
        child_category: [],
        media: {
          current_page: 1,
          data: [],
          from: null,
          last_page: 0,
          next_page_url: null,
          path: "https://theclarkson.broker-application.com/api/get-list/659",
          per_page: 9,
          prev_page_url: null,
          to: null,
          total: 0,
        },
      },
      {
        id: 678,
        name: "WEST",
        parent_category: 665,
        child_category: [],
        media: {
          current_page: 1,
          data: [],
          from: null,
          last_page: 0,
          next_page_url: null,
          path: "https://theclarkson.broker-application.com/api/get-list/659",
          per_page: 9,
          prev_page_url: null,
          to: null,
          total: 0,
        },
      },
      {
        id: 679,
        name: "SOUTH",
        parent_category: 665,
        child_category: [],
        media: {
          current_page: 1,
          data: [],
          from: null,
          last_page: 0,
          next_page_url: null,
          path: "https://theclarkson.broker-application.com/api/get-list/659",
          per_page: 9,
          prev_page_url: null,
          to: null,
          total: 0,
        },
      },
    ],
    get_exit_players: [],
  },
  {
    id: 666,
    name: "ARRIVAL",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 659,
      name: "MODEL GALLERY",
      category_image: "",
      primary_media: 581,
      secondary_media: null,
      second_image: "no",
      parent_category: null,
      hardware_id: 43,
      instance_player: "",
      secondary_player: 43,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [],
    get_exit_players: [],
  },
  {
    id: 667,
    name: "AMENITIES",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 659,
      name: "MODEL GALLERY",
      category_image: "",
      primary_media: 581,
      secondary_media: null,
      second_image: "no",
      parent_category: null,
      hardware_id: 43,
      instance_player: "",
      secondary_player: 43,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [],
    get_exit_players: [],
  },
  {
    id: 668,
    name: "RESIDENCES",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 659,
      name: "MODEL GALLERY",
      category_image: "",
      primary_media: 581,
      secondary_media: null,
      second_image: "no",
      parent_category: null,
      hardware_id: 43,
      instance_player: "",
      secondary_player: 43,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "property",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [],
    get_exit_players: [],
  },
];

export const floorData = {
  674: [
    {
      id: 2204,
      category_id: {
        id: 674,
        name: "UPPER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 512,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: 43,
      gallery_type: "image",
      title: "Library",
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/POOL.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/POOL.jpg",
      media_categories: [],
      media: {
        id: 512,
        folder_id: 52,
        media_name: "POOL.jpg",
        media_url: "POOL.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:35",
        updated_at: "2024-06-11 01:35:35",
      },
    },
    {
      id: 2205,
      category_id: {
        id: 674,
        name: "UPPER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 511,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: 43,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/LIBRARY.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/LIBRARY.jpg",
      media_categories: [],
      media: {
        id: 511,
        folder_id: 52,
        media_name: "LIBRARY.jpg",
        media_url: "LIBRARY.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:34",
        updated_at: "2024-06-11 01:35:34",
      },
    },
    {
      id: 2206,
      category_id: {
        id: 674,
        name: "UPPER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 515,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: 43,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/WINTER-GARDEN.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/WINTER-GARDEN.jpg",
      media_categories: [],
      media: {
        id: 515,
        folder_id: 52,
        media_name: "WINTER GARDEN.jpg",
        media_url: "WINTER-GARDEN.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:38",
        updated_at: "2024-06-11 01:35:38",
      },
    },
    {
      id: 2207,
      category_id: {
        id: 674,
        name: "UPPER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 513,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: 43,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/PRIVATE-DINING-ROOM.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/PRIVATE-DINING-ROOM.jpg",
      media_categories: [],
      media: {
        id: 513,
        folder_id: 52,
        media_name: "PRIVATE DINING ROOM.jpg",
        media_url: "PRIVATE-DINING-ROOM.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:36",
        updated_at: "2024-06-11 01:35:36",
      },
    },
    {
      id: 2208,
      category_id: {
        id: 674,
        name: "UPPER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 514,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: 43,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/RESTAURANT.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/RESTAURANT.jpg",
      media_categories: [],
      media: {
        id: 514,
        folder_id: 52,
        media_name: "RESTAURANT.jpg",
        media_url: "RESTAURANT.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:36",
        updated_at: "2024-06-11 01:35:36",
      },
    },
    {
      id: 2209,
      category_id: {
        id: 674,
        name: "UPPER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 516,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: 43,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/ROOF-DINING-AREA.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/ROOF-DINING-AREA.jpg",
      media_categories: [],
      media: {
        id: 516,
        folder_id: 52,
        media_name: "ROOF DINING AREA.jpg",
        media_url: "ROOF-DINING-AREA.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:38",
        updated_at: "2024-06-11 01:35:38",
      },
    },
    {
      id: 2210,
      category_id: {
        id: 674,
        name: "UPPER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 517,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: 43,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/YOGA---PILATES.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/YOGA---PILATES.jpg",
      media_categories: [],
      media: {
        id: 517,
        folder_id: 52,
        media_name: "YOGA & PILATES.jpg",
        media_url: "YOGA---PILATES.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:41",
        updated_at: "2024-06-11 01:35:41",
      },
    },
  ],
  675: [
    {
      id: 2211,
      category_id: {
        id: 675,
        name: "LOWER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 508,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: 43,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/thumb/MULTI-SPORTS-COURT.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/MULTI-SPORTS-COURT.jpg",
      media_categories: [],
      media: {
        id: 508,
        folder_id: 53,
        media_name: "MULTI-SPORTS COURT.jpg",
        media_url: "MULTI-SPORTS-COURT.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:14",
        updated_at: "2024-06-11 01:35:14",
      },
    },
    {
      id: 2212,
      category_id: {
        id: 675,
        name: "LOWER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 510,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: null,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/thumb/SQUASH-COURT.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/SQUASH-COURT.jpg",
      media_categories: [],
      media: {
        id: 510,
        folder_id: 53,
        media_name: "SQUASH COURT.jpg",
        media_url: "SQUASH-COURT.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:17",
        updated_at: "2024-06-11 01:35:17",
      },
    },
    {
      id: 2213,
      category_id: {
        id: 675,
        name: "LOWER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 507,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: null,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/thumb/HAMMAM.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/HAMMAM.jpg",
      media_categories: [],
      media: {
        id: 507,
        folder_id: 53,
        media_name: "HAMMAM.jpg",
        media_url: "HAMMAM.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:13",
        updated_at: "2024-06-11 01:35:13",
      },
    },
    {
      id: 2214,
      category_id: {
        id: 675,
        name: "LOWER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 504,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: null,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/thumb/CINEMA.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/CINEMA.jpg",
      media_categories: [],
      media: {
        id: 504,
        folder_id: 53,
        media_name: "CINEMA.jpg",
        media_url: "CINEMA.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:10",
        updated_at: "2024-06-11 01:35:10",
      },
    },
    {
      id: 2215,
      category_id: {
        id: 675,
        name: "LOWER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 509,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: null,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/thumb/MUSIC-ROOM.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/MUSIC-ROOM.jpg",
      media_categories: [],
      media: {
        id: 509,
        folder_id: 53,
        media_name: "MUSIC ROOM.jpg",
        media_url: "MUSIC-ROOM.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:15",
        updated_at: "2024-06-11 01:35:15",
      },
    },
    {
      id: 2216,
      category_id: {
        id: 675,
        name: "LOWER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 505,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: null,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/thumb/CHILDREN-S-PLAYROOM.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/CHILDREN-S-PLAYROOM.jpg",
      media_categories: [],
      media: {
        id: 505,
        folder_id: 53,
        media_name: "CHILDREN'S PLAYROOM.jpg",
        media_url: "CHILDREN-S-PLAYROOM.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:11",
        updated_at: "2024-06-11 01:35:11",
      },
    },
    {
      id: 2217,
      category_id: {
        id: 675,
        name: "LOWER FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 506,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: null,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/thumb/GAME-ROOM.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/lower/GAME-ROOM.jpg",
      media_categories: [],
      media: {
        id: 506,
        folder_id: 53,
        media_name: "GAME ROOM.jpg",
        media_url: "GAME-ROOM.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:35:13",
        updated_at: "2024-06-11 01:35:13",
      },
    },
  ],
  676: [
    {
      id: 2218,
      category_id: {
        id: 676,
        name: "GROUND FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 502,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: 43,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/thumb/PORT-COCHERE-ENTRY.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/PORT-COCHERE-ENTRY.jpg",
      media_categories: [],
      media: {
        id: 502,
        folder_id: 54,
        media_name: "PORT COCHERE ENTRY.jpg",
        media_url: "PORT-COCHERE-ENTRY.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:34:57",
        updated_at: "2024-06-11 01:34:57",
      },
    },
    {
      id: 2219,
      category_id: {
        id: 676,
        name: "GROUND FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 503,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: null,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/thumb/PORT-COCHERE.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/PORT-COCHERE.jpg",
      media_categories: [],
      media: {
        id: 503,
        folder_id: 54,
        media_name: "PORT COCHERE.jpg",
        media_url: "PORT-COCHERE.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:34:58",
        updated_at: "2024-06-11 01:34:58",
      },
    },
    {
      id: 2220,
      category_id: {
        id: 676,
        name: "GROUND FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 500,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: null,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/thumb/LOBBY.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/LOBBY.jpg",
      media_categories: [],
      media: {
        id: 500,
        folder_id: 54,
        media_name: "LOBBY.jpg",
        media_url: "LOBBY.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:34:54",
        updated_at: "2024-06-11 01:34:54",
      },
    },
    {
      id: 2221,
      category_id: {
        id: 676,
        name: "GROUND FLOOR",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 661,
        hardware_id: null,
        instance_player: "",
        secondary_player: null,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "media_category",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
      media_id: 501,
      parent_id: null,
      server_c_string: "000",
      deselect_string: "000",
      hardware_id: null,
      gallery_type: "image",
      title: null,
      description: null,
      gallery_order: 0,
      thumb_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/thumb/FITNESS-CENTER.jpg",
      image_name:
        "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/FITNESS-CENTER.jpg",
      media_categories: [],
      media: {
        id: 501,
        folder_id: 54,
        media_name: "FITNESS CENTER.jpg",
        media_url: "FITNESS-CENTER.jpg",
        media_type: "image",
        status: "active",
        created_at: "2024-06-11 01:34:54",
        updated_at: "2024-06-11 01:34:54",
      },
    },
  ],
};

export const greatRoomData = [
  {
    id: 680,
    name: "WEST",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 662,
      name: "GREAT ROOM",
      category_image: "",
      primary_media: 580,
      secondary_media: null,
      second_image: "no",
      parent_category: null,
      hardware_id: null,
      instance_player: "",
      secondary_player: null,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [
      {
        id: 682,
        name: "14TH FLOOR",
        parent_category: 680,
        child_category: [
          {
            id: 683,
            name: "AFTERNOON",
            parent_category: 682,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
          {
            id: 684,
            name: "SUNSET",
            parent_category: 682,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
          {
            id: 685,
            name: "DUSK",
            parent_category: 682,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
        ],
        media: {
          current_page: 1,
          data: [],
          from: null,
          last_page: 0,
          next_page_url: null,
          path: "https://theclarkson.broker-application.com/api/get-list/662",
          per_page: 9,
          prev_page_url: null,
          to: null,
          total: 0,
        },
      },
      {
        id: 686,
        name: "22ND FLOOR",
        parent_category: 680,
        child_category: [
          {
            id: 687,
            name: "AFTERNOON",
            parent_category: 686,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
          {
            id: 688,
            name: "SUNSET",
            parent_category: 686,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
          {
            id: 689,
            name: "DUSK",
            parent_category: 686,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
        ],
        media: {
          current_page: 1,
          data: [],
          from: null,
          last_page: 0,
          next_page_url: null,
          path: "https://theclarkson.broker-application.com/api/get-list/662",
          per_page: 9,
          prev_page_url: null,
          to: null,
          total: 0,
        },
      },
      {
        id: 694,
        name: "34TH FLOOR",
        parent_category: 680,
        child_category: [
          {
            id: 695,
            name: "AFTERNOON",
            parent_category: 694,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
          {
            id: 696,
            name: "SUNSET",
            parent_category: 694,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
          {
            id: 697,
            name: "DUSK",
            parent_category: 694,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
        ],
        media: {
          current_page: 1,
          data: [],
          from: null,
          last_page: 0,
          next_page_url: null,
          path: "https://theclarkson.broker-application.com/api/get-list/662",
          per_page: 9,
          prev_page_url: null,
          to: null,
          total: 0,
        },
      },
    ],
    get_exit_players: [],
  },
  {
    id: 681,
    name: "SOUTH",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 662,
      name: "GREAT ROOM",
      category_image: "",
      primary_media: 580,
      secondary_media: null,
      second_image: "no",
      parent_category: null,
      hardware_id: null,
      instance_player: "",
      secondary_player: null,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [
      {
        id: 698,
        name: "28TH FLOOR",
        parent_category: 681,
        child_category: [
          {
            id: 699,
            name: "AFTERNOON",
            parent_category: 698,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
          {
            id: 700,
            name: "SUNSET",
            parent_category: 698,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
          {
            id: 701,
            name: "DUSK",
            parent_category: 698,
            child_category: [],
            media: {
              current_page: 1,
              data: [],
              from: null,
              last_page: 0,
              next_page_url: null,
              path: "https://theclarkson.broker-application.com/api/get-list/662",
              per_page: 9,
              prev_page_url: null,
              to: null,
              total: 0,
            },
          },
        ],
        media: {
          current_page: 1,
          data: [],
          from: null,
          last_page: 0,
          next_page_url: null,
          path: "https://theclarkson.broker-application.com/api/get-list/662",
          per_page: 9,
          prev_page_url: null,
          to: null,
          total: 0,
        },
      },
    ],
    get_exit_players: [],
  },
];

export const loungeRoomData = [
  {
    id: 702,
    name: "80 CLARKSON",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 663,
      name: "LOUNGE ROOM",
      category_image: "",
      primary_media: 580,
      secondary_media: null,
      second_image: "no",
      parent_category: null,
      hardware_id: null,
      instance_player: "",
      secondary_player: null,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: 43,
    instance_player: null,
    secondary_player: "43",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [
      {
        id: 705,
        name: "BUILDING",
        parent_category: 702,
        child_category: [],
        media: [
          {
            id: 2222,
            category_id: 705,
            media_id: 560,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-West-Tower-2.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-West-Tower-2.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building West Tower 2.jpg",
            secondary_image: [],
            get_media: {
              id: 560,
              folder_id: 62,
              media_name: "Building West Tower 2.jpg",
              media_url: "Building-West-Tower-2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:16",
              updated_at: "2024-06-11 02:05:16",
            },
          },
          {
            id: 2223,
            category_id: 705,
            media_id: 559,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-West-Tower-4.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-West-Tower-4.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building West Tower 4.jpg",
            secondary_image: [],
            get_media: {
              id: 559,
              folder_id: 62,
              media_name: "Building West Tower 4.jpg",
              media_url: "Building-West-Tower-4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:16",
              updated_at: "2024-06-11 02:05:16",
            },
          },
          {
            id: 2224,
            category_id: 705,
            media_id: 554,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-South-Tower-1.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-South-Tower-1.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building South Tower 1.jpg",
            secondary_image: [],
            get_media: {
              id: 554,
              folder_id: 62,
              media_name: "Building South Tower 1.jpg",
              media_url: "Building-South-Tower-1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:10",
              updated_at: "2024-06-11 02:05:10",
            },
          },
          {
            id: 2225,
            category_id: 705,
            media_id: 553,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-South-Tower-2.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-South-Tower-2.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building South Tower 2.jpg",
            secondary_image: [],
            get_media: {
              id: 553,
              folder_id: 62,
              media_name: "Building South Tower 2.jpg",
              media_url: "Building-South-Tower-2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:09",
              updated_at: "2024-06-11 02:05:09",
            },
          },
          {
            id: 2226,
            category_id: 705,
            media_id: 552,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-Hero-4.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-Hero-4.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building Hero 4.jpg",
            secondary_image: [],
            get_media: {
              id: 552,
              folder_id: 62,
              media_name: "Building Hero 4.jpg",
              media_url: "Building-Hero-4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:07",
              updated_at: "2024-06-11 02:05:07",
            },
          },
          {
            id: 2227,
            category_id: 705,
            media_id: 558,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-West-Tower-3.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-West-Tower-3.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building West Tower 3.jpg",
            secondary_image: [],
            get_media: {
              id: 558,
              folder_id: 62,
              media_name: "Building West Tower 3.jpg",
              media_url: "Building-West-Tower-3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:14",
              updated_at: "2024-06-11 02:05:14",
            },
          },
          {
            id: 2228,
            category_id: 705,
            media_id: 557,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-South-Tower-4.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-South-Tower-4.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building South Tower 4.jpg",
            secondary_image: [],
            get_media: {
              id: 557,
              folder_id: 62,
              media_name: "Building South Tower 4.jpg",
              media_url: "Building-South-Tower-4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:13",
              updated_at: "2024-06-11 02:05:13",
            },
          },
          {
            id: 2229,
            category_id: 705,
            media_id: 551,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-Hero-3.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-Hero-3.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building Hero 3.jpg",
            secondary_image: [],
            get_media: {
              id: 551,
              folder_id: 62,
              media_name: "Building Hero 3.jpg",
              media_url: "Building-Hero-3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:07",
              updated_at: "2024-06-11 02:05:07",
            },
          },
          {
            id: 2230,
            category_id: 705,
            media_id: 556,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-West-Tower-1.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-West-Tower-1.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building West Tower 1.jpg",
            secondary_image: [],
            get_media: {
              id: 556,
              folder_id: 62,
              media_name: "Building West Tower 1.jpg",
              media_url: "Building-West-Tower-1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:12",
              updated_at: "2024-06-11 02:05:12",
            },
          },
          {
            id: 2231,
            category_id: 705,
            media_id: 550,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-Hero-1.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-Hero-1.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building Hero 1.jpg",
            secondary_image: [],
            get_media: {
              id: 550,
              folder_id: 62,
              media_name: "Building Hero 1.jpg",
              media_url: "Building-Hero-1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:05",
              updated_at: "2024-06-11 02:05:05",
            },
          },
          {
            id: 2232,
            category_id: 705,
            media_id: 555,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-South-Tower-3.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-South-Tower-3.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building South Tower 3.jpg",
            secondary_image: [],
            get_media: {
              id: 555,
              folder_id: 62,
              media_name: "Building South Tower 3.jpg",
              media_url: "Building-South-Tower-3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:11",
              updated_at: "2024-06-11 02:05:11",
            },
          },
          {
            id: 2233,
            category_id: 705,
            media_id: 549,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/thumb/Building-Hero-2.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/1-building/Building-Hero-2.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Building Hero 2.jpg",
            secondary_image: [],
            get_media: {
              id: 549,
              folder_id: 62,
              media_name: "Building Hero 2.jpg",
              media_url: "Building-Hero-2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:05",
              updated_at: "2024-06-11 02:05:05",
            },
          },
        ],
      },
      {
        id: 706,
        name: "RESIDENCES",
        parent_category: 702,
        child_category: [],
        media: [
          {
            id: 2234,
            category_id: 706,
            media_id: 569,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/thumb/Ground-Floor-2.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/Ground-Floor-2.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Ground Floor 2.jpg",
            secondary_image: [],
            get_media: {
              id: 569,
              folder_id: 64,
              media_name: "Ground Floor 2.jpg",
              media_url: "Ground-Floor-2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:48",
              updated_at: "2024-06-11 02:05:48",
            },
          },
          {
            id: 2235,
            category_id: 706,
            media_id: 575,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/thumb/Lower-Floor-3.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/Lower-Floor-3.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Lower Floor 3.jpg",
            secondary_image: [],
            get_media: {
              id: 575,
              folder_id: 64,
              media_name: "Lower Floor 3.jpg",
              media_url: "Lower-Floor-3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:53",
              updated_at: "2024-06-11 02:05:53",
            },
          },
          {
            id: 2236,
            category_id: 706,
            media_id: 570,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/thumb/Ground-Floor-1.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/Ground-Floor-1.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Ground Floor 1.jpg",
            secondary_image: [],
            get_media: {
              id: 570,
              folder_id: 64,
              media_name: "Ground Floor 1.jpg",
              media_url: "Ground-Floor-1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:48",
              updated_at: "2024-06-11 02:05:48",
            },
          },
          {
            id: 2237,
            category_id: 706,
            media_id: 576,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/thumb/Upper-Floor-1.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/Upper-Floor-1.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Upper Floor 1.jpg",
            secondary_image: [],
            get_media: {
              id: 576,
              folder_id: 64,
              media_name: "Upper Floor 1.jpg",
              media_url: "Upper-Floor-1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:54",
              updated_at: "2024-06-11 02:05:54",
            },
          },
          {
            id: 2238,
            category_id: 706,
            media_id: 571,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/thumb/Ground-Floor-3.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/Ground-Floor-3.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Ground Floor 3.jpg",
            secondary_image: [],
            get_media: {
              id: 571,
              folder_id: 64,
              media_name: "Ground Floor 3.jpg",
              media_url: "Ground-Floor-3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:49",
              updated_at: "2024-06-11 02:05:49",
            },
          },
          {
            id: 2239,
            category_id: 706,
            media_id: 577,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/thumb/Upper-Floor-2.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/2-residences/gallery/3-amenities/Upper-Floor-2.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Upper Floor 2.jpg",
            secondary_image: [],
            get_media: {
              id: 577,
              folder_id: 64,
              media_name: "Upper Floor 2.jpg",
              media_url: "Upper-Floor-2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 02:05:55",
              updated_at: "2024-06-11 02:05:55",
            },
          },
        ],
      },
      {
        id: 707,
        name: "AMENITIES",
        parent_category: 702,
        child_category: [],
        media: [
          {
            id: 2240,
            category_id: 707,
            media_id: 517,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/YOGA---PILATES.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/YOGA---PILATES.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "YOGA & PILATES.jpg",
            secondary_image: [],
            get_media: {
              id: 517,
              folder_id: 52,
              media_name: "YOGA & PILATES.jpg",
              media_url: "YOGA---PILATES.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 01:35:41",
              updated_at: "2024-06-11 01:35:41",
            },
          },
          {
            id: 2241,
            category_id: 707,
            media_id: 515,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/WINTER-GARDEN.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/WINTER-GARDEN.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "WINTER GARDEN.jpg",
            secondary_image: [],
            get_media: {
              id: 515,
              folder_id: 52,
              media_name: "WINTER GARDEN.jpg",
              media_url: "WINTER-GARDEN.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 01:35:38",
              updated_at: "2024-06-11 01:35:38",
            },
          },
          {
            id: 2242,
            category_id: 707,
            media_id: 513,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/PRIVATE-DINING-ROOM.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/PRIVATE-DINING-ROOM.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "PRIVATE DINING ROOM.jpg",
            secondary_image: [],
            get_media: {
              id: 513,
              folder_id: 52,
              media_name: "PRIVATE DINING ROOM.jpg",
              media_url: "PRIVATE-DINING-ROOM.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 01:35:36",
              updated_at: "2024-06-11 01:35:36",
            },
          },
          {
            id: 2243,
            category_id: 707,
            media_id: 512,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/POOL.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/POOL.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "POOL.jpg",
            secondary_image: [],
            get_media: {
              id: 512,
              folder_id: 52,
              media_name: "POOL.jpg",
              media_url: "POOL.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 01:35:35",
              updated_at: "2024-06-11 01:35:35",
            },
          },
          {
            id: 2244,
            category_id: 707,
            media_id: 514,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/RESTAURANT.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/RESTAURANT.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "RESTAURANT.jpg",
            secondary_image: [],
            get_media: {
              id: 514,
              folder_id: 52,
              media_name: "RESTAURANT.jpg",
              media_url: "RESTAURANT.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 01:35:36",
              updated_at: "2024-06-11 01:35:36",
            },
          },
          {
            id: 2245,
            category_id: 707,
            media_id: 516,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/ROOF-DINING-AREA.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/ROOF-DINING-AREA.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "ROOF DINING AREA.jpg",
            secondary_image: [],
            get_media: {
              id: 516,
              folder_id: 52,
              media_name: "ROOF DINING AREA.jpg",
              media_url: "ROOF-DINING-AREA.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 01:35:38",
              updated_at: "2024-06-11 01:35:38",
            },
          },
          {
            id: 2246,
            category_id: 707,
            media_id: 511,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/thumb/LIBRARY.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/upper/LIBRARY.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "LIBRARY.jpg",
            secondary_image: [],
            get_media: {
              id: 511,
              folder_id: 52,
              media_name: "LIBRARY.jpg",
              media_url: "LIBRARY.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 01:35:34",
              updated_at: "2024-06-11 01:35:34",
            },
          },
          {
            id: 2247,
            category_id: 707,
            media_id: 503,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/thumb/PORT-COCHERE.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/PORT-COCHERE.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "PORT COCHERE.jpg",
            secondary_image: [],
            get_media: {
              id: 503,
              folder_id: 54,
              media_name: "PORT COCHERE.jpg",
              media_url: "PORT-COCHERE.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 01:34:58",
              updated_at: "2024-06-11 01:34:58",
            },
          },
          {
            id: 2248,
            category_id: 707,
            media_id: 502,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/thumb/PORT-COCHERE-ENTRY.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/PORT-COCHERE-ENTRY.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "PORT COCHERE ENTRY.jpg",
            secondary_image: [],
            get_media: {
              id: 502,
              folder_id: 54,
              media_name: "PORT COCHERE ENTRY.jpg",
              media_url: "PORT-COCHERE-ENTRY.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 01:34:57",
              updated_at: "2024-06-11 01:34:57",
            },
          },
          {
            id: 2249,
            category_id: 707,
            media_id: 501,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/thumb/FITNESS-CENTER.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/FITNESS-CENTER.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "FITNESS CENTER.jpg",
            secondary_image: [],
            get_media: {
              id: 501,
              folder_id: 54,
              media_name: "FITNESS CENTER.jpg",
              media_url: "FITNESS-CENTER.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 01:34:54",
              updated_at: "2024-06-11 01:34:54",
            },
          },
          {
            id: 2250,
            category_id: 707,
            media_id: 500,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/thumb/LOBBY.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/placeholder-images/amenities/ground/LOBBY.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "LOBBY.jpg",
            secondary_image: [],
            get_media: {
              id: 500,
              folder_id: 54,
              media_name: "LOBBY.jpg",
              media_url: "LOBBY.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-06-11 01:34:54",
              updated_at: "2024-06-11 01:34:54",
            },
          },
        ],
      },
      {
        id: 708,
        name: "TEAM",
        parent_category: 702,
        child_category: [],
        media: [
          {
            id: 2344,
            category_id: 708,
            media_id: 838,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "Group 4",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%201.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%201.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 838,
              folder_id: 93,
              media_name: "G4 Image 1.jpg",
              media_url: "G4 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:41",
              updated_at: "2024-07-08 07:11:41",
            },
          },
          {
            id: 2345,
            category_id: 708,
            media_id: 835,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%202.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%202.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 835,
              folder_id: 93,
              media_name: "G4 Image 2.jpg",
              media_url: "G4 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:39",
              updated_at: "2024-07-08 07:11:39",
            },
          },
          {
            id: 2346,
            category_id: 708,
            media_id: 837,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%203.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%203.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 837,
              folder_id: 93,
              media_name: "G4 Image 3.jpg",
              media_url: "G4 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:40",
              updated_at: "2024-07-08 07:11:40",
            },
          },
          {
            id: 2347,
            category_id: 708,
            media_id: 840,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%204.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%204.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 840,
              folder_id: 93,
              media_name: "G4 Image 4.jpg",
              media_url: "G4 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:42",
              updated_at: "2024-07-08 07:11:42",
            },
          },
          {
            id: 2348,
            category_id: 708,
            media_id: 839,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%205.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%205.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 839,
              folder_id: 93,
              media_name: "G4 Image 5.jpg",
              media_url: "G4 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:41",
              updated_at: "2024-07-08 07:11:41",
            },
          },
          {
            id: 2349,
            category_id: 708,
            media_id: 834,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%206.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%206.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 834,
              folder_id: 93,
              media_name: "G4 Image 6.jpg",
              media_url: "G4 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:38",
              updated_at: "2024-07-08 07:11:38",
            },
          },
          {
            id: 2350,
            category_id: 708,
            media_id: 841,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%207.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%207.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 841,
              folder_id: 93,
              media_name: "G4 Image 7.jpg",
              media_url: "G4 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:43",
              updated_at: "2024-07-08 07:11:43",
            },
          },
          {
            id: 2351,
            category_id: 708,
            media_id: 843,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%208.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%208.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 843,
              folder_id: 93,
              media_name: "G4 Image 8.jpg",
              media_url: "G4 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:44",
              updated_at: "2024-07-08 07:11:44",
            },
          },
          {
            id: 2352,
            category_id: 708,
            media_id: 842,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%209.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%209.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 842,
              folder_id: 93,
              media_name: "G4 Image 9.jpg",
              media_url: "G4 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:43",
              updated_at: "2024-07-08 07:11:43",
            },
          },
          {
            id: 2353,
            category_id: 708,
            media_id: 836,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%2010.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%2010.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 836,
              folder_id: 93,
              media_name: "G4 Image 10.jpg",
              media_url: "G4 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:40",
              updated_at: "2024-07-08 07:11:40",
            },
          },
        ],
      },
    ],
    get_exit_players: [],
  },
  {
    id: 703,
    name: "NEIGHBORHOOD",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 663,
      name: "LOUNGE ROOM",
      category_image: "",
      primary_media: 580,
      secondary_media: null,
      second_image: "no",
      parent_category: null,
      hardware_id: null,
      instance_player: "",
      secondary_player: null,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: 43,
    instance_player: null,
    secondary_player: "43",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [
      {
        id: 709,
        name: "MAPS",
        parent_category: 703,
        child_category: [],
        media: [
          {
            id: 2354,
            category_id: 709,
            media_id: 838,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%201.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%201.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 838,
              folder_id: 93,
              media_name: "G4 Image 1.jpg",
              media_url: "G4 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:41",
              updated_at: "2024-07-08 07:11:41",
            },
          },
          {
            id: 2355,
            category_id: 709,
            media_id: 835,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%202.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%202.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 835,
              folder_id: 93,
              media_name: "G4 Image 2.jpg",
              media_url: "G4 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:39",
              updated_at: "2024-07-08 07:11:39",
            },
          },
          {
            id: 2356,
            category_id: 709,
            media_id: 837,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%203.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%203.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 837,
              folder_id: 93,
              media_name: "G4 Image 3.jpg",
              media_url: "G4 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:40",
              updated_at: "2024-07-08 07:11:40",
            },
          },
          {
            id: 2357,
            category_id: 709,
            media_id: 840,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%204.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%204.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 840,
              folder_id: 93,
              media_name: "G4 Image 4.jpg",
              media_url: "G4 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:42",
              updated_at: "2024-07-08 07:11:42",
            },
          },
          {
            id: 2358,
            category_id: 709,
            media_id: 839,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%205.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%205.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 839,
              folder_id: 93,
              media_name: "G4 Image 5.jpg",
              media_url: "G4 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:41",
              updated_at: "2024-07-08 07:11:41",
            },
          },
          {
            id: 2359,
            category_id: 709,
            media_id: 834,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%206.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%206.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 834,
              folder_id: 93,
              media_name: "G4 Image 6.jpg",
              media_url: "G4 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:38",
              updated_at: "2024-07-08 07:11:38",
            },
          },
          {
            id: 2360,
            category_id: 709,
            media_id: 841,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%207.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%207.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 841,
              folder_id: 93,
              media_name: "G4 Image 7.jpg",
              media_url: "G4 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:43",
              updated_at: "2024-07-08 07:11:43",
            },
          },
          {
            id: 2361,
            category_id: 709,
            media_id: 843,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%208.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%208.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 843,
              folder_id: 93,
              media_name: "G4 Image 8.jpg",
              media_url: "G4 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:44",
              updated_at: "2024-07-08 07:11:44",
            },
          },
          {
            id: 2362,
            category_id: 709,
            media_id: 842,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%209.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%209.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 842,
              folder_id: 93,
              media_name: "G4 Image 9.jpg",
              media_url: "G4 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:43",
              updated_at: "2024-07-08 07:11:43",
            },
          },
          {
            id: 2363,
            category_id: 709,
            media_id: 836,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%2010.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%2010.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 836,
              folder_id: 93,
              media_name: "G4 Image 10.jpg",
              media_url: "G4 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:40",
              updated_at: "2024-07-08 07:11:40",
            },
          },
        ],
      },
      {
        id: 710,
        name: "DINING",
        parent_category: 703,
        child_category: [],
        media: [
          {
            id: 2364,
            category_id: 710,
            media_id: 828,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 828,
              folder_id: 84,
              media_name: "G2 Image 1.jpg",
              media_url: "G2 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:34",
              updated_at: "2024-07-08 07:11:34",
            },
          },
          {
            id: 2365,
            category_id: 710,
            media_id: 829,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 829,
              folder_id: 84,
              media_name: "G2 Image 9.jpg",
              media_url: "G2 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:35",
              updated_at: "2024-07-08 07:11:35",
            },
          },
          {
            id: 2366,
            category_id: 710,
            media_id: 830,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 830,
              folder_id: 84,
              media_name: "G2 Image 2.jpg",
              media_url: "G2 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:36",
              updated_at: "2024-07-08 07:11:36",
            },
          },
          {
            id: 2367,
            category_id: 710,
            media_id: 824,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 824,
              folder_id: 84,
              media_name: "G2 Image 3.jpg",
              media_url: "G2 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:32",
              updated_at: "2024-07-08 07:11:32",
            },
          },
          {
            id: 2368,
            category_id: 710,
            media_id: 825,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 825,
              folder_id: 84,
              media_name: "G2 Image 4.jpg",
              media_url: "G2 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:33",
              updated_at: "2024-07-08 07:11:33",
            },
          },
          {
            id: 2369,
            category_id: 710,
            media_id: 831,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 831,
              folder_id: 84,
              media_name: "G2 Image 10.jpg",
              media_url: "G2 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:36",
              updated_at: "2024-07-08 07:11:36",
            },
          },
          {
            id: 2370,
            category_id: 710,
            media_id: 832,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 832,
              folder_id: 84,
              media_name: "G2 Image 5.jpg",
              media_url: "G2 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:37",
              updated_at: "2024-07-08 07:11:37",
            },
          },
          {
            id: 2371,
            category_id: 710,
            media_id: 826,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 826,
              folder_id: 84,
              media_name: "G2 Image 8.jpg",
              media_url: "G2 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:33",
              updated_at: "2024-07-08 07:11:33",
            },
          },
          {
            id: 2372,
            category_id: 710,
            media_id: 827,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 827,
              folder_id: 84,
              media_name: "G2 Image 7.jpg",
              media_url: "G2 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:34",
              updated_at: "2024-07-08 07:11:34",
            },
          },
          {
            id: 2373,
            category_id: 710,
            media_id: 833,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 833,
              folder_id: 84,
              media_name: "G2 Image 6.jpg",
              media_url: "G2 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:38",
              updated_at: "2024-07-08 07:11:38",
            },
          },
        ],
      },
      {
        id: 711,
        name: "ARTS & CULTURE",
        parent_category: 703,
        child_category: [],
        media: [
          {
            id: 2374,
            category_id: 711,
            media_id: 868,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%204.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%204.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 868,
              folder_id: 96,
              media_name: "G5 Image 4.jpg",
              media_url: "G5 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:59",
              updated_at: "2024-07-08 07:11:59",
            },
          },
          {
            id: 2375,
            category_id: 711,
            media_id: 867,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%205.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%205.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 867,
              folder_id: 96,
              media_name: "G5 Image 5.jpg",
              media_url: "G5 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:59",
              updated_at: "2024-07-08 07:11:59",
            },
          },
          {
            id: 2376,
            category_id: 711,
            media_id: 866,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%206.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%206.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 866,
              folder_id: 96,
              media_name: "G5 Image 6.jpg",
              media_url: "G5 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:58",
              updated_at: "2024-07-08 07:11:58",
            },
          },
          {
            id: 2377,
            category_id: 711,
            media_id: 865,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%207.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%207.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 865,
              folder_id: 96,
              media_name: "G5 Image 7.jpg",
              media_url: "G5 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:57",
              updated_at: "2024-07-08 07:11:57",
            },
          },
          {
            id: 2378,
            category_id: 711,
            media_id: 864,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%202.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%202.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 864,
              folder_id: 96,
              media_name: "G5 Image 2.jpg",
              media_url: "G5 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:57",
              updated_at: "2024-07-08 07:11:57",
            },
          },
          {
            id: 2379,
            category_id: 711,
            media_id: 863,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%208.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%208.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 863,
              folder_id: 96,
              media_name: "G5 Image 8.jpg",
              media_url: "G5 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:56",
              updated_at: "2024-07-08 07:11:56",
            },
          },
          {
            id: 2380,
            category_id: 711,
            media_id: 859,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%2010.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%2010.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 859,
              folder_id: 96,
              media_name: "G5 Image 10.jpg",
              media_url: "G5 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:54",
              updated_at: "2024-07-08 07:11:54",
            },
          },
          {
            id: 2381,
            category_id: 711,
            media_id: 860,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%209.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%209.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 860,
              folder_id: 96,
              media_name: "G5 Image 9.jpg",
              media_url: "G5 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:54",
              updated_at: "2024-07-08 07:11:54",
            },
          },
          {
            id: 2382,
            category_id: 711,
            media_id: 861,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%201.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%201.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 861,
              folder_id: 96,
              media_name: "G5 Image 1.jpg",
              media_url: "G5 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:55",
              updated_at: "2024-07-08 07:11:55",
            },
          },
          {
            id: 2383,
            category_id: 711,
            media_id: 862,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%203.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%203.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 862,
              folder_id: 96,
              media_name: "G5 Image 3.jpg",
              media_url: "G5 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:55",
              updated_at: "2024-07-08 07:11:55",
            },
          },
        ],
      },
      {
        id: 712,
        name: "PARKS",
        parent_category: 703,
        child_category: [],
        media: [
          {
            id: 2384,
            category_id: 712,
            media_id: 841,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%207.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%207.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 841,
              folder_id: 93,
              media_name: "G4 Image 7.jpg",
              media_url: "G4 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:43",
              updated_at: "2024-07-08 07:11:43",
            },
          },
          {
            id: 2385,
            category_id: 712,
            media_id: 835,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%202.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%202.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 835,
              folder_id: 93,
              media_name: "G4 Image 2.jpg",
              media_url: "G4 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:39",
              updated_at: "2024-07-08 07:11:39",
            },
          },
          {
            id: 2386,
            category_id: 712,
            media_id: 834,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%206.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%206.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 834,
              folder_id: 93,
              media_name: "G4 Image 6.jpg",
              media_url: "G4 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:38",
              updated_at: "2024-07-08 07:11:38",
            },
          },
          {
            id: 2387,
            category_id: 712,
            media_id: 840,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%204.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%204.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 840,
              folder_id: 93,
              media_name: "G4 Image 4.jpg",
              media_url: "G4 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:42",
              updated_at: "2024-07-08 07:11:42",
            },
          },
          {
            id: 2388,
            category_id: 712,
            media_id: 839,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%205.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%205.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 839,
              folder_id: 93,
              media_name: "G4 Image 5.jpg",
              media_url: "G4 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:41",
              updated_at: "2024-07-08 07:11:41",
            },
          },
          {
            id: 2389,
            category_id: 712,
            media_id: 838,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%201.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%201.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 838,
              folder_id: 93,
              media_name: "G4 Image 1.jpg",
              media_url: "G4 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:41",
              updated_at: "2024-07-08 07:11:41",
            },
          },
          {
            id: 2390,
            category_id: 712,
            media_id: 842,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%209.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%209.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 842,
              folder_id: 93,
              media_name: "G4 Image 9.jpg",
              media_url: "G4 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:43",
              updated_at: "2024-07-08 07:11:43",
            },
          },
          {
            id: 2391,
            category_id: 712,
            media_id: 843,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%208.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%208.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 843,
              folder_id: 93,
              media_name: "G4 Image 8.jpg",
              media_url: "G4 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:44",
              updated_at: "2024-07-08 07:11:44",
            },
          },
          {
            id: 2392,
            category_id: 712,
            media_id: 837,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%203.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%203.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 837,
              folder_id: 93,
              media_name: "G4 Image 3.jpg",
              media_url: "G4 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:40",
              updated_at: "2024-07-08 07:11:40",
            },
          },
          {
            id: 2393,
            category_id: 712,
            media_id: 836,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%2010.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%2010.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 836,
              folder_id: 93,
              media_name: "G4 Image 10.jpg",
              media_url: "G4 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:40",
              updated_at: "2024-07-08 07:11:40",
            },
          },
        ],
      },
      {
        id: 713,
        name: "SHOPPING",
        parent_category: 703,
        child_category: [],
        media: [
          {
            id: 2394,
            category_id: 713,
            media_id: 878,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 878,
              folder_id: 97,
              media_name: "G1 Image 10.jpg",
              media_url: "G1 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:06",
              updated_at: "2024-07-08 07:12:06",
            },
          },
          {
            id: 2395,
            category_id: 713,
            media_id: 872,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 872,
              folder_id: 97,
              media_name: "G1 Image 2.jpg",
              media_url: "G1 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:02",
              updated_at: "2024-07-08 07:12:02",
            },
          },
          {
            id: 2396,
            category_id: 713,
            media_id: 871,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 871,
              folder_id: 97,
              media_name: "G1 Image 5.jpg",
              media_url: "G1 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:01",
              updated_at: "2024-07-08 07:12:01",
            },
          },
          {
            id: 2397,
            category_id: 713,
            media_id: 877,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 877,
              folder_id: 97,
              media_name: "G1 Image 6.jpg",
              media_url: "G1 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:05",
              updated_at: "2024-07-08 07:12:05",
            },
          },
          {
            id: 2398,
            category_id: 713,
            media_id: 876,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 876,
              folder_id: 97,
              media_name: "G1 Image 7.jpg",
              media_url: "G1 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:04",
              updated_at: "2024-07-08 07:12:04",
            },
          },
          {
            id: 2399,
            category_id: 713,
            media_id: 870,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 870,
              folder_id: 97,
              media_name: "G1 Image 3.jpg",
              media_url: "G1 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:00",
              updated_at: "2024-07-08 07:12:00",
            },
          },
          {
            id: 2400,
            category_id: 713,
            media_id: 869,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 869,
              folder_id: 97,
              media_name: "G1 Image 8.jpg",
              media_url: "G1 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:00",
              updated_at: "2024-07-08 07:12:00",
            },
          },
          {
            id: 2401,
            category_id: 713,
            media_id: 875,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 875,
              folder_id: 97,
              media_name: "G1 Image 1.jpg",
              media_url: "G1 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:04",
              updated_at: "2024-07-08 07:12:04",
            },
          },
          {
            id: 2402,
            category_id: 713,
            media_id: 873,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 873,
              folder_id: 97,
              media_name: "G1 Image 9.jpg",
              media_url: "G1 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:03",
              updated_at: "2024-07-08 07:12:03",
            },
          },
          {
            id: 2403,
            category_id: 713,
            media_id: 874,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 874,
              folder_id: 97,
              media_name: "G1 Image 4.jpg",
              media_url: "G1 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:03",
              updated_at: "2024-07-08 07:12:03",
            },
          },
        ],
      },
      {
        id: 714,
        name: "LIFESTYLE",
        parent_category: 703,
        child_category: [],
        media: [
          {
            id: 2404,
            category_id: 714,
            media_id: 853,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%2010.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 853,
              folder_id: 94,
              media_name: "G3 Image 10.jpg",
              media_url: "G3 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:50",
              updated_at: "2024-07-08 07:11:50",
            },
          },
          {
            id: 2405,
            category_id: 714,
            media_id: 847,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%206.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%206.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 847,
              folder_id: 94,
              media_name: "G3 Image 6.jpg",
              media_url: "G3 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:46",
              updated_at: "2024-07-08 07:11:46",
            },
          },
          {
            id: 2406,
            category_id: 714,
            media_id: 846,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%203.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%203.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 846,
              folder_id: 94,
              media_name: "G3 Image 3.jpg",
              media_url: "G3 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:46",
              updated_at: "2024-07-08 07:11:46",
            },
          },
          {
            id: 2407,
            category_id: 714,
            media_id: 852,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%207.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%207.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 852,
              folder_id: 94,
              media_name: "G3 Image 7.jpg",
              media_url: "G3 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:49",
              updated_at: "2024-07-08 07:11:49",
            },
          },
          {
            id: 2408,
            category_id: 714,
            media_id: 851,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%201.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%201.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 851,
              folder_id: 94,
              media_name: "G3 Image 1.jpg",
              media_url: "G3 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:49",
              updated_at: "2024-07-08 07:11:49",
            },
          },
          {
            id: 2409,
            category_id: 714,
            media_id: 845,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%204.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%204.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 845,
              folder_id: 94,
              media_name: "G3 Image 4.jpg",
              media_url: "G3 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:45",
              updated_at: "2024-07-08 07:11:45",
            },
          },
          {
            id: 2410,
            category_id: 714,
            media_id: 844,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%202.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%202.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 844,
              folder_id: 94,
              media_name: "G3 Image 2.jpg",
              media_url: "G3 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:44",
              updated_at: "2024-07-08 07:11:44",
            },
          },
          {
            id: 2411,
            category_id: 714,
            media_id: 850,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%208.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%208.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 850,
              folder_id: 94,
              media_name: "G3 Image 8.jpg",
              media_url: "G3 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:48",
              updated_at: "2024-07-08 07:11:48",
            },
          },
          {
            id: 2412,
            category_id: 714,
            media_id: 849,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 849,
              folder_id: 94,
              media_name: "G3 Image 9.jpg",
              media_url: "G3 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:47",
              updated_at: "2024-07-08 07:11:47",
            },
          },
          {
            id: 2413,
            category_id: 714,
            media_id: 848,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 848,
              folder_id: 94,
              media_name: "G3 Image 5.jpg",
              media_url: "G3 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:47",
              updated_at: "2024-07-08 07:11:47",
            },
          },
        ],
      },
      {
        id: 715,
        name: "BARS",
        parent_category: 703,
        child_category: [],
        media: [
          {
            id: 2414,
            category_id: 715,
            media_id: 858,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Rendering 5.jpg",
            secondary_image: [],
            get_media: {
              id: 858,
              folder_id: 95,
              media_name: "Rendering 5.jpg",
              media_url: "Rendering 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:53",
              updated_at: "2024-07-08 07:11:53",
            },
          },
          {
            id: 2415,
            category_id: 715,
            media_id: 857,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/renderings/thumb/Rendering%204.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/renderings/Rendering%204.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Rendering 4.jpg",
            secondary_image: [],
            get_media: {
              id: 857,
              folder_id: 95,
              media_name: "Rendering 4.jpg",
              media_url: "Rendering 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:52",
              updated_at: "2024-07-08 07:11:52",
            },
          },
          {
            id: 2416,
            category_id: 715,
            media_id: 856,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/renderings/thumb/Rendering%201.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/renderings/Rendering%201.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Rendering 1.jpg",
            secondary_image: [],
            get_media: {
              id: 856,
              folder_id: 95,
              media_name: "Rendering 1.jpg",
              media_url: "Rendering 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:52",
              updated_at: "2024-07-08 07:11:52",
            },
          },
          {
            id: 2417,
            category_id: 715,
            media_id: 855,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/renderings/thumb/Rendering%202.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/renderings/Rendering%202.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Rendering 2.jpg",
            secondary_image: [],
            get_media: {
              id: 855,
              folder_id: 95,
              media_name: "Rendering 2.jpg",
              media_url: "Rendering 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:51",
              updated_at: "2024-07-08 07:11:51",
            },
          },
          {
            id: 2418,
            category_id: 715,
            media_id: 854,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/renderings/thumb/Rendering%203.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/renderings/Rendering%203.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "Rendering 3.jpg",
            secondary_image: [],
            get_media: {
              id: 854,
              folder_id: 95,
              media_name: "Rendering 3.jpg",
              media_url: "Rendering 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:51",
              updated_at: "2024-07-08 07:11:51",
            },
          },
        ],
      },
    ],
    get_exit_players: [],
  },
  {
    id: 704,
    name: "FLOORPLANS",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 663,
      name: "LOUNGE ROOM",
      category_image: "",
      primary_media: 580,
      secondary_media: null,
      second_image: "no",
      parent_category: null,
      hardware_id: null,
      instance_player: "",
      secondary_player: null,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: 43,
    instance_player: null,
    secondary_player: "43",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "property",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [],
    get_exit_players: [],
  },
];

export const amenitiesFilmdata = [
  {
    id: 669,
    name: "AMENITIES FILM",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 660,
      name: "AMENITIES DISPLAY",
      category_image: "",
      primary_media: 579,
      secondary_media: null,
      second_image: "no",
      parent_category: null,
      hardware_id: null,
      instance_player: "",
      secondary_player: null,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "media_category",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [],
    get_exit_players: [],
  },
  {
    id: 670,
    name: "GALLERY",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 660,
      name: "AMENITIES DISPLAY",
      category_image: "",
      primary_media: 579,
      secondary_media: null,
      second_image: "no",
      parent_category: null,
      hardware_id: null,
      instance_player: "",
      secondary_player: null,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: null,
    instance_player: null,
    secondary_player: "",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [
      {
        id: 730,
        name: "BUILDING",
        parent_category: 670,
        child_category: [
          {
            id: 733,
            name: "HERO",
            parent_category: 730,
            child_category: [],
            media: [
              {
                id: 2263,
                category_id: 733,
                media_id: 875,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "Image1",
                description: null,
                gallery_order: 1,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 1.jpg",
                secondary_image: [],
                get_media: {
                  id: 875,
                  folder_id: 97,
                  media_name: "G1 Image 1.jpg",
                  media_url: "G1 Image 1.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:04",
                  updated_at: "2024-07-08 07:12:04",
                },
              },
              {
                id: 2264,
                category_id: 733,
                media_id: 872,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 2,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 2.jpg",
                secondary_image: [],
                get_media: {
                  id: 872,
                  folder_id: 97,
                  media_name: "G1 Image 2.jpg",
                  media_url: "G1 Image 2.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:02",
                  updated_at: "2024-07-08 07:12:02",
                },
              },
              {
                id: 2265,
                category_id: 733,
                media_id: 870,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 3,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 3.jpg",
                secondary_image: [],
                get_media: {
                  id: 870,
                  folder_id: 97,
                  media_name: "G1 Image 3.jpg",
                  media_url: "G1 Image 3.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:00",
                  updated_at: "2024-07-08 07:12:00",
                },
              },
              {
                id: 2266,
                category_id: 733,
                media_id: 874,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 4,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 4.jpg",
                secondary_image: [],
                get_media: {
                  id: 874,
                  folder_id: 97,
                  media_name: "G1 Image 4.jpg",
                  media_url: "G1 Image 4.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:03",
                  updated_at: "2024-07-08 07:12:03",
                },
              },
              {
                id: 2267,
                category_id: 733,
                media_id: 871,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 5,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 5.jpg",
                secondary_image: [],
                get_media: {
                  id: 871,
                  folder_id: 97,
                  media_name: "G1 Image 5.jpg",
                  media_url: "G1 Image 5.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:01",
                  updated_at: "2024-07-08 07:12:01",
                },
              },
              {
                id: 2268,
                category_id: 733,
                media_id: 877,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 6,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 6.jpg",
                secondary_image: [],
                get_media: {
                  id: 877,
                  folder_id: 97,
                  media_name: "G1 Image 6.jpg",
                  media_url: "G1 Image 6.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:05",
                  updated_at: "2024-07-08 07:12:05",
                },
              },
              {
                id: 2269,
                category_id: 733,
                media_id: 876,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 7,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 7.jpg",
                secondary_image: [],
                get_media: {
                  id: 876,
                  folder_id: 97,
                  media_name: "G1 Image 7.jpg",
                  media_url: "G1 Image 7.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:04",
                  updated_at: "2024-07-08 07:12:04",
                },
              },
              {
                id: 2270,
                category_id: 733,
                media_id: 869,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 8,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 8.jpg",
                secondary_image: [],
                get_media: {
                  id: 869,
                  folder_id: 97,
                  media_name: "G1 Image 8.jpg",
                  media_url: "G1 Image 8.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:00",
                  updated_at: "2024-07-08 07:12:00",
                },
              },
              {
                id: 2271,
                category_id: 733,
                media_id: 873,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 9,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 9.jpg",
                secondary_image: [],
                get_media: {
                  id: 873,
                  folder_id: 97,
                  media_name: "G1 Image 9.jpg",
                  media_url: "G1 Image 9.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:03",
                  updated_at: "2024-07-08 07:12:03",
                },
              },
              {
                id: 2272,
                category_id: 733,
                media_id: 878,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 10,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 10.jpg",
                secondary_image: [],
                get_media: {
                  id: 878,
                  folder_id: 97,
                  media_name: "G1 Image 10.jpg",
                  media_url: "G1 Image 10.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:06",
                  updated_at: "2024-07-08 07:12:06",
                },
              },
            ],
          },
          {
            id: 734,
            name: "WEST TOWER",
            parent_category: 730,
            child_category: [],
            media: [
              {
                id: 2273,
                category_id: 734,
                media_id: 828,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "Group 2",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 1.jpg",
                secondary_image: [],
                get_media: {
                  id: 828,
                  folder_id: 84,
                  media_name: "G2 Image 1.jpg",
                  media_url: "G2 Image 1.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:34",
                  updated_at: "2024-07-08 07:11:34",
                },
              },
              {
                id: 2274,
                category_id: 734,
                media_id: 830,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 2.jpg",
                secondary_image: [],
                get_media: {
                  id: 830,
                  folder_id: 84,
                  media_name: "G2 Image 2.jpg",
                  media_url: "G2 Image 2.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:36",
                  updated_at: "2024-07-08 07:11:36",
                },
              },
              {
                id: 2275,
                category_id: 734,
                media_id: 824,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 3.jpg",
                secondary_image: [],
                get_media: {
                  id: 824,
                  folder_id: 84,
                  media_name: "G2 Image 3.jpg",
                  media_url: "G2 Image 3.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:32",
                  updated_at: "2024-07-08 07:11:32",
                },
              },
              {
                id: 2276,
                category_id: 734,
                media_id: 825,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 4.jpg",
                secondary_image: [],
                get_media: {
                  id: 825,
                  folder_id: 84,
                  media_name: "G2 Image 4.jpg",
                  media_url: "G2 Image 4.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:33",
                  updated_at: "2024-07-08 07:11:33",
                },
              },
              {
                id: 2277,
                category_id: 734,
                media_id: 832,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 5.jpg",
                secondary_image: [],
                get_media: {
                  id: 832,
                  folder_id: 84,
                  media_name: "G2 Image 5.jpg",
                  media_url: "G2 Image 5.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:37",
                  updated_at: "2024-07-08 07:11:37",
                },
              },
              {
                id: 2278,
                category_id: 734,
                media_id: 833,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 6.jpg",
                secondary_image: [],
                get_media: {
                  id: 833,
                  folder_id: 84,
                  media_name: "G2 Image 6.jpg",
                  media_url: "G2 Image 6.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:38",
                  updated_at: "2024-07-08 07:11:38",
                },
              },
              {
                id: 2279,
                category_id: 734,
                media_id: 827,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 7.jpg",
                secondary_image: [],
                get_media: {
                  id: 827,
                  folder_id: 84,
                  media_name: "G2 Image 7.jpg",
                  media_url: "G2 Image 7.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:34",
                  updated_at: "2024-07-08 07:11:34",
                },
              },
              {
                id: 2280,
                category_id: 734,
                media_id: 826,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 8.jpg",
                secondary_image: [],
                get_media: {
                  id: 826,
                  folder_id: 84,
                  media_name: "G2 Image 8.jpg",
                  media_url: "G2 Image 8.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:33",
                  updated_at: "2024-07-08 07:11:33",
                },
              },
              {
                id: 2281,
                category_id: 734,
                media_id: 829,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 9.jpg",
                secondary_image: [],
                get_media: {
                  id: 829,
                  folder_id: 84,
                  media_name: "G2 Image 9.jpg",
                  media_url: "G2 Image 9.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:35",
                  updated_at: "2024-07-08 07:11:35",
                },
              },
              {
                id: 2282,
                category_id: 734,
                media_id: 831,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 10.jpg",
                secondary_image: [],
                get_media: {
                  id: 831,
                  folder_id: 84,
                  media_name: "G2 Image 10.jpg",
                  media_url: "G2 Image 10.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:36",
                  updated_at: "2024-07-08 07:11:36",
                },
              },
            ],
          },
          {
            id: 735,
            name: "SOUTH TOWER",
            parent_category: 730,
            child_category: [],
            media: [
              {
                id: 2283,
                category_id: 735,
                media_id: 851,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%201.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%201.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 1.jpg",
                secondary_image: [],
                get_media: {
                  id: 851,
                  folder_id: 94,
                  media_name: "G3 Image 1.jpg",
                  media_url: "G3 Image 1.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:49",
                  updated_at: "2024-07-08 07:11:49",
                },
              },
              {
                id: 2284,
                category_id: 735,
                media_id: 844,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%202.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%202.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 2.jpg",
                secondary_image: [],
                get_media: {
                  id: 844,
                  folder_id: 94,
                  media_name: "G3 Image 2.jpg",
                  media_url: "G3 Image 2.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:44",
                  updated_at: "2024-07-08 07:11:44",
                },
              },
              {
                id: 2285,
                category_id: 735,
                media_id: 846,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%203.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%203.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 3.jpg",
                secondary_image: [],
                get_media: {
                  id: 846,
                  folder_id: 94,
                  media_name: "G3 Image 3.jpg",
                  media_url: "G3 Image 3.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:46",
                  updated_at: "2024-07-08 07:11:46",
                },
              },
              {
                id: 2286,
                category_id: 735,
                media_id: 845,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%204.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%204.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 4.jpg",
                secondary_image: [],
                get_media: {
                  id: 845,
                  folder_id: 94,
                  media_name: "G3 Image 4.jpg",
                  media_url: "G3 Image 4.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:45",
                  updated_at: "2024-07-08 07:11:45",
                },
              },
              {
                id: 2287,
                category_id: 735,
                media_id: 848,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 5.jpg",
                secondary_image: [],
                get_media: {
                  id: 848,
                  folder_id: 94,
                  media_name: "G3 Image 5.jpg",
                  media_url: "G3 Image 5.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:47",
                  updated_at: "2024-07-08 07:11:47",
                },
              },
              {
                id: 2288,
                category_id: 735,
                media_id: 847,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%206.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%206.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 6.jpg",
                secondary_image: [],
                get_media: {
                  id: 847,
                  folder_id: 94,
                  media_name: "G3 Image 6.jpg",
                  media_url: "G3 Image 6.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:46",
                  updated_at: "2024-07-08 07:11:46",
                },
              },
              {
                id: 2289,
                category_id: 735,
                media_id: 852,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%207.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%207.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 7.jpg",
                secondary_image: [],
                get_media: {
                  id: 852,
                  folder_id: 94,
                  media_name: "G3 Image 7.jpg",
                  media_url: "G3 Image 7.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:49",
                  updated_at: "2024-07-08 07:11:49",
                },
              },
              {
                id: 2290,
                category_id: 735,
                media_id: 850,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%208.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%208.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 8.jpg",
                secondary_image: [],
                get_media: {
                  id: 850,
                  folder_id: 94,
                  media_name: "G3 Image 8.jpg",
                  media_url: "G3 Image 8.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:48",
                  updated_at: "2024-07-08 07:11:48",
                },
              },
              {
                id: 2291,
                category_id: 735,
                media_id: 849,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%209.jpg",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 9.jpg",
                secondary_image: [],
                get_media: {
                  id: 849,
                  folder_id: 94,
                  media_name: "G3 Image 9.jpg",
                  media_url: "G3 Image 9.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:47",
                  updated_at: "2024-07-08 07:11:47",
                },
              },
              {
                id: 2292,
                category_id: 735,
                media_id: 853,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%2010.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 10.jpg",
                secondary_image: [],
                get_media: {
                  id: 853,
                  folder_id: 94,
                  media_name: "G3 Image 10.jpg",
                  media_url: "G3 Image 10.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:50",
                  updated_at: "2024-07-08 07:11:50",
                },
              },
            ],
          },
        ],
        media: {
          current_page: 1,
          data: [],
          from: null,
          last_page: 0,
          next_page_url: null,
          path: "https://theclarkson.broker-application.com/api/get-list/660",
          per_page: 9,
          prev_page_url: null,
          to: null,
          total: 0,
        },
      },
      {
        id: 731,
        name: "RESIDENCES",
        parent_category: 670,
        child_category: [
          {
            id: 736,
            name: "WEST TOWER",
            parent_category: 731,
            child_category: [],
            media: [
              {
                id: 2293,
                category_id: 736,
                media_id: 838,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%201.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%201.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G4 Image 1.jpg",
                secondary_image: [],
                get_media: {
                  id: 838,
                  folder_id: 93,
                  media_name: "G4 Image 1.jpg",
                  media_url: "G4 Image 1.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:41",
                  updated_at: "2024-07-08 07:11:41",
                },
              },
              {
                id: 2294,
                category_id: 736,
                media_id: 835,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%202.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%202.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G4 Image 2.jpg",
                secondary_image: [],
                get_media: {
                  id: 835,
                  folder_id: 93,
                  media_name: "G4 Image 2.jpg",
                  media_url: "G4 Image 2.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:39",
                  updated_at: "2024-07-08 07:11:39",
                },
              },
              {
                id: 2295,
                category_id: 736,
                media_id: 837,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%203.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%203.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G4 Image 3.jpg",
                secondary_image: [],
                get_media: {
                  id: 837,
                  folder_id: 93,
                  media_name: "G4 Image 3.jpg",
                  media_url: "G4 Image 3.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:40",
                  updated_at: "2024-07-08 07:11:40",
                },
              },
              {
                id: 2296,
                category_id: 736,
                media_id: 840,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%204.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%204.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G4 Image 4.jpg",
                secondary_image: [],
                get_media: {
                  id: 840,
                  folder_id: 93,
                  media_name: "G4 Image 4.jpg",
                  media_url: "G4 Image 4.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:42",
                  updated_at: "2024-07-08 07:11:42",
                },
              },
              {
                id: 2297,
                category_id: 736,
                media_id: 839,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%205.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%205.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G4 Image 5.jpg",
                secondary_image: [],
                get_media: {
                  id: 839,
                  folder_id: 93,
                  media_name: "G4 Image 5.jpg",
                  media_url: "G4 Image 5.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:41",
                  updated_at: "2024-07-08 07:11:41",
                },
              },
              {
                id: 2298,
                category_id: 736,
                media_id: 834,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%206.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%206.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G4 Image 6.jpg",
                secondary_image: [],
                get_media: {
                  id: 834,
                  folder_id: 93,
                  media_name: "G4 Image 6.jpg",
                  media_url: "G4 Image 6.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:38",
                  updated_at: "2024-07-08 07:11:38",
                },
              },
              {
                id: 2299,
                category_id: 736,
                media_id: 841,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%207.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%207.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G4 Image 7.jpg",
                secondary_image: [],
                get_media: {
                  id: 841,
                  folder_id: 93,
                  media_name: "G4 Image 7.jpg",
                  media_url: "G4 Image 7.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:43",
                  updated_at: "2024-07-08 07:11:43",
                },
              },
              {
                id: 2300,
                category_id: 736,
                media_id: 843,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%208.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%208.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G4 Image 8.jpg",
                secondary_image: [],
                get_media: {
                  id: 843,
                  folder_id: 93,
                  media_name: "G4 Image 8.jpg",
                  media_url: "G4 Image 8.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:44",
                  updated_at: "2024-07-08 07:11:44",
                },
              },
              {
                id: 2301,
                category_id: 736,
                media_id: 842,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%209.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%209.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G4 Image 9.jpg",
                secondary_image: [],
                get_media: {
                  id: 842,
                  folder_id: 93,
                  media_name: "G4 Image 9.jpg",
                  media_url: "G4 Image 9.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:43",
                  updated_at: "2024-07-08 07:11:43",
                },
              },
              {
                id: 2302,
                category_id: 736,
                media_id: 836,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%2010.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%2010.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G4 Image 10.jpg",
                secondary_image: [],
                get_media: {
                  id: 836,
                  folder_id: 93,
                  media_name: "G4 Image 10.jpg",
                  media_url: "G4 Image 10.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:40",
                  updated_at: "2024-07-08 07:11:40",
                },
              },
            ],
          },
          {
            id: 737,
            name: "SOUTH TOWER",
            parent_category: 731,
            child_category: [],
            media: [
              {
                id: 2304,
                category_id: 737,
                media_id: 864,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%202.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%202.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G5 Image 2.jpg",
                secondary_image: [],
                get_media: {
                  id: 864,
                  folder_id: 96,
                  media_name: "G5 Image 2.jpg",
                  media_url: "G5 Image 2.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:57",
                  updated_at: "2024-07-08 07:11:57",
                },
              },
              {
                id: 2305,
                category_id: 737,
                media_id: 862,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%203.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%203.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G5 Image 3.jpg",
                secondary_image: [],
                get_media: {
                  id: 862,
                  folder_id: 96,
                  media_name: "G5 Image 3.jpg",
                  media_url: "G5 Image 3.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:55",
                  updated_at: "2024-07-08 07:11:55",
                },
              },
              {
                id: 2306,
                category_id: 737,
                media_id: 868,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%204.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%204.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G5 Image 4.jpg",
                secondary_image: [],
                get_media: {
                  id: 868,
                  folder_id: 96,
                  media_name: "G5 Image 4.jpg",
                  media_url: "G5 Image 4.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:59",
                  updated_at: "2024-07-08 07:11:59",
                },
              },
              {
                id: 2307,
                category_id: 737,
                media_id: 867,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%205.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%205.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G5 Image 5.jpg",
                secondary_image: [],
                get_media: {
                  id: 867,
                  folder_id: 96,
                  media_name: "G5 Image 5.jpg",
                  media_url: "G5 Image 5.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:59",
                  updated_at: "2024-07-08 07:11:59",
                },
              },
              {
                id: 2308,
                category_id: 737,
                media_id: 866,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%206.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%206.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G5 Image 6.jpg",
                secondary_image: [],
                get_media: {
                  id: 866,
                  folder_id: 96,
                  media_name: "G5 Image 6.jpg",
                  media_url: "G5 Image 6.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:58",
                  updated_at: "2024-07-08 07:11:58",
                },
              },
              {
                id: 2309,
                category_id: 737,
                media_id: 865,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%207.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%207.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G5 Image 7.jpg",
                secondary_image: [],
                get_media: {
                  id: 865,
                  folder_id: 96,
                  media_name: "G5 Image 7.jpg",
                  media_url: "G5 Image 7.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:57",
                  updated_at: "2024-07-08 07:11:57",
                },
              },
              {
                id: 2310,
                category_id: 737,
                media_id: 863,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%208.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%208.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G5 Image 8.jpg",
                secondary_image: [],
                get_media: {
                  id: 863,
                  folder_id: 96,
                  media_name: "G5 Image 8.jpg",
                  media_url: "G5 Image 8.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:56",
                  updated_at: "2024-07-08 07:11:56",
                },
              },
              {
                id: 2311,
                category_id: 737,
                media_id: 860,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%209.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%209.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G5 Image 9.jpg",
                secondary_image: [],
                get_media: {
                  id: 860,
                  folder_id: 96,
                  media_name: "G5 Image 9.jpg",
                  media_url: "G5 Image 9.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:54",
                  updated_at: "2024-07-08 07:11:54",
                },
              },
              {
                id: 2312,
                category_id: 737,
                media_id: 859,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%2010.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%2010.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G5 Image 10.jpg",
                secondary_image: [],
                get_media: {
                  id: 859,
                  folder_id: 96,
                  media_name: "G5 Image 10.jpg",
                  media_url: "G5 Image 10.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:54",
                  updated_at: "2024-07-08 07:11:54",
                },
              },
              {
                id: 2303,
                category_id: 737,
                media_id: 861,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%201.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%201.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G5 Image 1.jpg",
                secondary_image: [],
                get_media: {
                  id: 861,
                  folder_id: 96,
                  media_name: "G5 Image 1.jpg",
                  media_url: "G5 Image 1.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:55",
                  updated_at: "2024-07-08 07:11:55",
                },
              },
            ],
          },
        ],
        media: {
          current_page: 1,
          data: [],
          from: null,
          last_page: 0,
          next_page_url: null,
          path: "https://theclarkson.broker-application.com/api/get-list/660",
          per_page: 9,
          prev_page_url: null,
          to: null,
          total: 0,
        },
      },
      {
        id: 732,
        name: "AMENITIES",
        parent_category: 670,
        child_category: [
          {
            id: 738,
            name: "LOWER FLOOR",
            parent_category: 732,
            child_category: [],
            media: [
              {
                id: 2314,
                category_id: 738,
                media_id: 875,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 1.jpg",
                secondary_image: [],
                get_media: {
                  id: 875,
                  folder_id: 97,
                  media_name: "G1 Image 1.jpg",
                  media_url: "G1 Image 1.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:04",
                  updated_at: "2024-07-08 07:12:04",
                },
              },
              {
                id: 2315,
                category_id: 738,
                media_id: 872,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 2.jpg",
                secondary_image: [],
                get_media: {
                  id: 872,
                  folder_id: 97,
                  media_name: "G1 Image 2.jpg",
                  media_url: "G1 Image 2.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:02",
                  updated_at: "2024-07-08 07:12:02",
                },
              },
              {
                id: 2316,
                category_id: 738,
                media_id: 870,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 3.jpg",
                secondary_image: [],
                get_media: {
                  id: 870,
                  folder_id: 97,
                  media_name: "G1 Image 3.jpg",
                  media_url: "G1 Image 3.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:00",
                  updated_at: "2024-07-08 07:12:00",
                },
              },
              {
                id: 2317,
                category_id: 738,
                media_id: 874,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 4.jpg",
                secondary_image: [],
                get_media: {
                  id: 874,
                  folder_id: 97,
                  media_name: "G1 Image 4.jpg",
                  media_url: "G1 Image 4.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:03",
                  updated_at: "2024-07-08 07:12:03",
                },
              },
              {
                id: 2318,
                category_id: 738,
                media_id: 871,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 5.jpg",
                secondary_image: [],
                get_media: {
                  id: 871,
                  folder_id: 97,
                  media_name: "G1 Image 5.jpg",
                  media_url: "G1 Image 5.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:01",
                  updated_at: "2024-07-08 07:12:01",
                },
              },
              {
                id: 2319,
                category_id: 738,
                media_id: 877,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 6.jpg",
                secondary_image: [],
                get_media: {
                  id: 877,
                  folder_id: 97,
                  media_name: "G1 Image 6.jpg",
                  media_url: "G1 Image 6.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:05",
                  updated_at: "2024-07-08 07:12:05",
                },
              },
              {
                id: 2320,
                category_id: 738,
                media_id: 876,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 7.jpg",
                secondary_image: [],
                get_media: {
                  id: 876,
                  folder_id: 97,
                  media_name: "G1 Image 7.jpg",
                  media_url: "G1 Image 7.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:04",
                  updated_at: "2024-07-08 07:12:04",
                },
              },
              {
                id: 2321,
                category_id: 738,
                media_id: 869,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 8.jpg",
                secondary_image: [],
                get_media: {
                  id: 869,
                  folder_id: 97,
                  media_name: "G1 Image 8.jpg",
                  media_url: "G1 Image 8.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:00",
                  updated_at: "2024-07-08 07:12:00",
                },
              },
              {
                id: 2322,
                category_id: 738,
                media_id: 873,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 9.jpg",
                secondary_image: [],
                get_media: {
                  id: 873,
                  folder_id: 97,
                  media_name: "G1 Image 9.jpg",
                  media_url: "G1 Image 9.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:03",
                  updated_at: "2024-07-08 07:12:03",
                },
              },
              {
                id: 2323,
                category_id: 738,
                media_id: 878,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G1 Image 10.jpg",
                secondary_image: [],
                get_media: {
                  id: 878,
                  folder_id: 97,
                  media_name: "G1 Image 10.jpg",
                  media_url: "G1 Image 10.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:12:06",
                  updated_at: "2024-07-08 07:12:06",
                },
              },
            ],
          },
          {
            id: 739,
            name: "GROUND FLOOR",
            parent_category: 732,
            child_category: [],
            media: [
              {
                id: 2324,
                category_id: 739,
                media_id: 828,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 1.jpg",
                secondary_image: [],
                get_media: {
                  id: 828,
                  folder_id: 84,
                  media_name: "G2 Image 1.jpg",
                  media_url: "G2 Image 1.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:34",
                  updated_at: "2024-07-08 07:11:34",
                },
              },
              {
                id: 2325,
                category_id: 739,
                media_id: 830,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 2.jpg",
                secondary_image: [],
                get_media: {
                  id: 830,
                  folder_id: 84,
                  media_name: "G2 Image 2.jpg",
                  media_url: "G2 Image 2.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:36",
                  updated_at: "2024-07-08 07:11:36",
                },
              },
              {
                id: 2326,
                category_id: 739,
                media_id: 824,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 3.jpg",
                secondary_image: [],
                get_media: {
                  id: 824,
                  folder_id: 84,
                  media_name: "G2 Image 3.jpg",
                  media_url: "G2 Image 3.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:32",
                  updated_at: "2024-07-08 07:11:32",
                },
              },
              {
                id: 2327,
                category_id: 739,
                media_id: 825,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 4.jpg",
                secondary_image: [],
                get_media: {
                  id: 825,
                  folder_id: 84,
                  media_name: "G2 Image 4.jpg",
                  media_url: "G2 Image 4.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:33",
                  updated_at: "2024-07-08 07:11:33",
                },
              },
              {
                id: 2328,
                category_id: 739,
                media_id: 832,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 5.jpg",
                secondary_image: [],
                get_media: {
                  id: 832,
                  folder_id: 84,
                  media_name: "G2 Image 5.jpg",
                  media_url: "G2 Image 5.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:37",
                  updated_at: "2024-07-08 07:11:37",
                },
              },
              {
                id: 2329,
                category_id: 739,
                media_id: 833,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 6.jpg",
                secondary_image: [],
                get_media: {
                  id: 833,
                  folder_id: 84,
                  media_name: "G2 Image 6.jpg",
                  media_url: "G2 Image 6.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:38",
                  updated_at: "2024-07-08 07:11:38",
                },
              },
              {
                id: 2330,
                category_id: 739,
                media_id: 827,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 7.jpg",
                secondary_image: [],
                get_media: {
                  id: 827,
                  folder_id: 84,
                  media_name: "G2 Image 7.jpg",
                  media_url: "G2 Image 7.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:34",
                  updated_at: "2024-07-08 07:11:34",
                },
              },
              {
                id: 2331,
                category_id: 739,
                media_id: 826,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 8.jpg",
                secondary_image: [],
                get_media: {
                  id: 826,
                  folder_id: 84,
                  media_name: "G2 Image 8.jpg",
                  media_url: "G2 Image 8.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:33",
                  updated_at: "2024-07-08 07:11:33",
                },
              },
              {
                id: 2332,
                category_id: 739,
                media_id: 829,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 9.jpg",
                secondary_image: [],
                get_media: {
                  id: 829,
                  folder_id: 84,
                  media_name: "G2 Image 9.jpg",
                  media_url: "G2 Image 9.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:35",
                  updated_at: "2024-07-08 07:11:35",
                },
              },
              {
                id: 2333,
                category_id: 739,
                media_id: 831,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G2 Image 10.jpg",
                secondary_image: [],
                get_media: {
                  id: 831,
                  folder_id: 84,
                  media_name: "G2 Image 10.jpg",
                  media_url: "G2 Image 10.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:36",
                  updated_at: "2024-07-08 07:11:36",
                },
              },
            ],
          },
          {
            id: 740,
            name: "UPPER FLOOR",
            parent_category: 732,
            child_category: [],
            media: [
              {
                id: 2334,
                category_id: 740,
                media_id: 851,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%201.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%201.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 1.jpg",
                secondary_image: [],
                get_media: {
                  id: 851,
                  folder_id: 94,
                  media_name: "G3 Image 1.jpg",
                  media_url: "G3 Image 1.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:49",
                  updated_at: "2024-07-08 07:11:49",
                },
              },
              {
                id: 2335,
                category_id: 740,
                media_id: 844,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%202.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%202.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 2.jpg",
                secondary_image: [],
                get_media: {
                  id: 844,
                  folder_id: 94,
                  media_name: "G3 Image 2.jpg",
                  media_url: "G3 Image 2.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:44",
                  updated_at: "2024-07-08 07:11:44",
                },
              },
              {
                id: 2336,
                category_id: 740,
                media_id: 846,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%203.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%203.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 3.jpg",
                secondary_image: [],
                get_media: {
                  id: 846,
                  folder_id: 94,
                  media_name: "G3 Image 3.jpg",
                  media_url: "G3 Image 3.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:46",
                  updated_at: "2024-07-08 07:11:46",
                },
              },
              {
                id: 2337,
                category_id: 740,
                media_id: 845,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%204.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%204.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 4.jpg",
                secondary_image: [],
                get_media: {
                  id: 845,
                  folder_id: 94,
                  media_name: "G3 Image 4.jpg",
                  media_url: "G3 Image 4.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:45",
                  updated_at: "2024-07-08 07:11:45",
                },
              },
              {
                id: 2338,
                category_id: 740,
                media_id: 848,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 5.jpg",
                secondary_image: [],
                get_media: {
                  id: 848,
                  folder_id: 94,
                  media_name: "G3 Image 5.jpg",
                  media_url: "G3 Image 5.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:47",
                  updated_at: "2024-07-08 07:11:47",
                },
              },
              {
                id: 2339,
                category_id: 740,
                media_id: 847,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%206.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%206.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 6.jpg",
                secondary_image: [],
                get_media: {
                  id: 847,
                  folder_id: 94,
                  media_name: "G3 Image 6.jpg",
                  media_url: "G3 Image 6.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:46",
                  updated_at: "2024-07-08 07:11:46",
                },
              },
              {
                id: 2340,
                category_id: 740,
                media_id: 852,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%207.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%207.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 7.jpg",
                secondary_image: [],
                get_media: {
                  id: 852,
                  folder_id: 94,
                  media_name: "G3 Image 7.jpg",
                  media_url: "G3 Image 7.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:49",
                  updated_at: "2024-07-08 07:11:49",
                },
              },
              {
                id: 2341,
                category_id: 740,
                media_id: 850,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%208.jpg",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%208.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 8.jpg",
                secondary_image: [],
                get_media: {
                  id: 850,
                  folder_id: 94,
                  media_name: "G3 Image 8.jpg",
                  media_url: "G3 Image 8.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:48",
                  updated_at: "2024-07-08 07:11:48",
                },
              },
              {
                id: 2342,
                category_id: 740,
                media_id: 849,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%209.jpg",
                image_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 9.jpg",
                secondary_image: [],
                get_media: {
                  id: 849,
                  folder_id: 94,
                  media_name: "G3 Image 9.jpg",
                  media_url: "G3 Image 9.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:47",
                  updated_at: "2024-07-08 07:11:47",
                },
              },
              {
                id: 2343,
                category_id: 740,
                media_id: 853,
                parent_id: null,
                server_c_string: "000",
                deselect_string: "000",
                hardware_id: 43,
                gallery_type: "image",
                title: "",
                description: null,
                gallery_order: 0,
                thumb_name:
                  "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                image_name:
                  "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%2010.jpg",
                hardware_details: {
                  id: 43,
                  name: "TheClarksonGallery",
                  pin: "098127",
                  refresh_action: null,
                  screensaver_id: 27,
                  start_time: "10",
                  screensaver_time: "20",
                  load_media_at_refresh: 0,
                  screensaver_trigger: 0,
                  refresh_time: "23:47:00",
                  gallery_load_time: 2,
                },
                file_name: "G3 Image 10.jpg",
                secondary_image: [],
                get_media: {
                  id: 853,
                  folder_id: 94,
                  media_name: "G3 Image 10.jpg",
                  media_url: "G3 Image 10.jpg",
                  media_type: "image",
                  status: "active",
                  created_at: "2024-07-08 07:11:50",
                  updated_at: "2024-07-08 07:11:50",
                },
              },
            ],
          },
        ],
        media: {
          current_page: 1,
          data: [],
          from: null,
          last_page: 0,
          next_page_url: null,
          path: "https://theclarkson.broker-application.com/api/get-list/660",
          per_page: 9,
          prev_page_url: null,
          to: null,
          total: 0,
        },
      },
    ],
    get_exit_players: [],
  },
];

export const amenitiesGalleryData = [
  {
    id: 730,
    name: "BUILDING",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 670,
      name: "GALLERY",
      category_image: "",
      primary_media: null,
      secondary_media: null,
      second_image: "no",
      parent_category: 660,
      hardware_id: null,
      instance_player: "",
      secondary_player: null,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: 43,
    instance_player: null,
    secondary_player: "43",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [
      {
        id: 733,
        name: "HERO",
        parent_category: 730,
        child_category: [],
        media: [
          {
            id: 2263,
            category_id: 733,
            media_id: 875,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "Image1",
            description: null,
            gallery_order: 1,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 875,
              folder_id: 97,
              media_name: "G1 Image 1.jpg",
              media_url: "G1 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:04",
              updated_at: "2024-07-08 07:12:04",
            },
          },
          {
            id: 2264,
            category_id: 733,
            media_id: 872,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 2,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 872,
              folder_id: 97,
              media_name: "G1 Image 2.jpg",
              media_url: "G1 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:02",
              updated_at: "2024-07-08 07:12:02",
            },
          },
          {
            id: 2265,
            category_id: 733,
            media_id: 870,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 3,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 870,
              folder_id: 97,
              media_name: "G1 Image 3.jpg",
              media_url: "G1 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:00",
              updated_at: "2024-07-08 07:12:00",
            },
          },
          {
            id: 2266,
            category_id: 733,
            media_id: 874,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 4,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 874,
              folder_id: 97,
              media_name: "G1 Image 4.jpg",
              media_url: "G1 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:03",
              updated_at: "2024-07-08 07:12:03",
            },
          },
          {
            id: 2267,
            category_id: 733,
            media_id: 871,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 5,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 871,
              folder_id: 97,
              media_name: "G1 Image 5.jpg",
              media_url: "G1 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:01",
              updated_at: "2024-07-08 07:12:01",
            },
          },
          {
            id: 2268,
            category_id: 733,
            media_id: 877,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 6,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 877,
              folder_id: 97,
              media_name: "G1 Image 6.jpg",
              media_url: "G1 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:05",
              updated_at: "2024-07-08 07:12:05",
            },
          },
          {
            id: 2269,
            category_id: 733,
            media_id: 876,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 7,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 876,
              folder_id: 97,
              media_name: "G1 Image 7.jpg",
              media_url: "G1 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:04",
              updated_at: "2024-07-08 07:12:04",
            },
          },
          {
            id: 2270,
            category_id: 733,
            media_id: 869,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 8,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 869,
              folder_id: 97,
              media_name: "G1 Image 8.jpg",
              media_url: "G1 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:00",
              updated_at: "2024-07-08 07:12:00",
            },
          },
          {
            id: 2271,
            category_id: 733,
            media_id: 873,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 9,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 873,
              folder_id: 97,
              media_name: "G1 Image 9.jpg",
              media_url: "G1 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:03",
              updated_at: "2024-07-08 07:12:03",
            },
          },
          {
            id: 2272,
            category_id: 733,
            media_id: 878,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 10,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 878,
              folder_id: 97,
              media_name: "G1 Image 10.jpg",
              media_url: "G1 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:06",
              updated_at: "2024-07-08 07:12:06",
            },
          },
        ],
      },
      {
        id: 734,
        name: "WEST TOWER",
        parent_category: 730,
        child_category: [],
        media: [
          {
            id: 2273,
            category_id: 734,
            media_id: 828,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "Group 2",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 828,
              folder_id: 84,
              media_name: "G2 Image 1.jpg",
              media_url: "G2 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:34",
              updated_at: "2024-07-08 07:11:34",
            },
          },
          {
            id: 2274,
            category_id: 734,
            media_id: 830,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 830,
              folder_id: 84,
              media_name: "G2 Image 2.jpg",
              media_url: "G2 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:36",
              updated_at: "2024-07-08 07:11:36",
            },
          },
          {
            id: 2275,
            category_id: 734,
            media_id: 824,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 824,
              folder_id: 84,
              media_name: "G2 Image 3.jpg",
              media_url: "G2 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:32",
              updated_at: "2024-07-08 07:11:32",
            },
          },
          {
            id: 2276,
            category_id: 734,
            media_id: 825,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 825,
              folder_id: 84,
              media_name: "G2 Image 4.jpg",
              media_url: "G2 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:33",
              updated_at: "2024-07-08 07:11:33",
            },
          },
          {
            id: 2277,
            category_id: 734,
            media_id: 832,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 832,
              folder_id: 84,
              media_name: "G2 Image 5.jpg",
              media_url: "G2 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:37",
              updated_at: "2024-07-08 07:11:37",
            },
          },
          {
            id: 2278,
            category_id: 734,
            media_id: 833,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 833,
              folder_id: 84,
              media_name: "G2 Image 6.jpg",
              media_url: "G2 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:38",
              updated_at: "2024-07-08 07:11:38",
            },
          },
          {
            id: 2279,
            category_id: 734,
            media_id: 827,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 827,
              folder_id: 84,
              media_name: "G2 Image 7.jpg",
              media_url: "G2 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:34",
              updated_at: "2024-07-08 07:11:34",
            },
          },
          {
            id: 2280,
            category_id: 734,
            media_id: 826,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 826,
              folder_id: 84,
              media_name: "G2 Image 8.jpg",
              media_url: "G2 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:33",
              updated_at: "2024-07-08 07:11:33",
            },
          },
          {
            id: 2281,
            category_id: 734,
            media_id: 829,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 829,
              folder_id: 84,
              media_name: "G2 Image 9.jpg",
              media_url: "G2 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:35",
              updated_at: "2024-07-08 07:11:35",
            },
          },
          {
            id: 2282,
            category_id: 734,
            media_id: 831,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 831,
              folder_id: 84,
              media_name: "G2 Image 10.jpg",
              media_url: "G2 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:36",
              updated_at: "2024-07-08 07:11:36",
            },
          },
        ],
      },
      {
        id: 735,
        name: "SOUTH TOWER",
        parent_category: 730,
        child_category: [],
        media: [
          {
            id: 2283,
            category_id: 735,
            media_id: 851,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%201.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%201.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 851,
              folder_id: 94,
              media_name: "G3 Image 1.jpg",
              media_url: "G3 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:49",
              updated_at: "2024-07-08 07:11:49",
            },
          },
          {
            id: 2284,
            category_id: 735,
            media_id: 844,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%202.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%202.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 844,
              folder_id: 94,
              media_name: "G3 Image 2.jpg",
              media_url: "G3 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:44",
              updated_at: "2024-07-08 07:11:44",
            },
          },
          {
            id: 2285,
            category_id: 735,
            media_id: 846,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%203.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%203.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 846,
              folder_id: 94,
              media_name: "G3 Image 3.jpg",
              media_url: "G3 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:46",
              updated_at: "2024-07-08 07:11:46",
            },
          },
          {
            id: 2286,
            category_id: 735,
            media_id: 845,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%204.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%204.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 845,
              folder_id: 94,
              media_name: "G3 Image 4.jpg",
              media_url: "G3 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:45",
              updated_at: "2024-07-08 07:11:45",
            },
          },
          {
            id: 2287,
            category_id: 735,
            media_id: 848,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 848,
              folder_id: 94,
              media_name: "G3 Image 5.jpg",
              media_url: "G3 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:47",
              updated_at: "2024-07-08 07:11:47",
            },
          },
          {
            id: 2288,
            category_id: 735,
            media_id: 847,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%206.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%206.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 847,
              folder_id: 94,
              media_name: "G3 Image 6.jpg",
              media_url: "G3 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:46",
              updated_at: "2024-07-08 07:11:46",
            },
          },
          {
            id: 2289,
            category_id: 735,
            media_id: 852,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%207.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%207.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 852,
              folder_id: 94,
              media_name: "G3 Image 7.jpg",
              media_url: "G3 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:49",
              updated_at: "2024-07-08 07:11:49",
            },
          },
          {
            id: 2290,
            category_id: 735,
            media_id: 850,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%208.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%208.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 850,
              folder_id: 94,
              media_name: "G3 Image 8.jpg",
              media_url: "G3 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:48",
              updated_at: "2024-07-08 07:11:48",
            },
          },
          {
            id: 2291,
            category_id: 735,
            media_id: 849,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%209.jpg",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 849,
              folder_id: 94,
              media_name: "G3 Image 9.jpg",
              media_url: "G3 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:47",
              updated_at: "2024-07-08 07:11:47",
            },
          },
          {
            id: 2292,
            category_id: 735,
            media_id: 853,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%2010.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 853,
              folder_id: 94,
              media_name: "G3 Image 10.jpg",
              media_url: "G3 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:50",
              updated_at: "2024-07-08 07:11:50",
            },
          },
        ],
      },
    ],
    get_exit_players: [],
  },
  {
    id: 731,
    name: "RESIDENCES",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 670,
      name: "GALLERY",
      category_image: "",
      primary_media: null,
      secondary_media: null,
      second_image: "no",
      parent_category: 660,
      hardware_id: null,
      instance_player: "",
      secondary_player: null,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: 43,
    instance_player: null,
    secondary_player: "43",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [
      {
        id: 736,
        name: "WEST TOWER",
        parent_category: 731,
        child_category: [],
        media: [
          {
            id: 2293,
            category_id: 736,
            media_id: 838,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%201.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%201.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 838,
              folder_id: 93,
              media_name: "G4 Image 1.jpg",
              media_url: "G4 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:41",
              updated_at: "2024-07-08 07:11:41",
            },
          },
          {
            id: 2294,
            category_id: 736,
            media_id: 835,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%202.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%202.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 835,
              folder_id: 93,
              media_name: "G4 Image 2.jpg",
              media_url: "G4 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:39",
              updated_at: "2024-07-08 07:11:39",
            },
          },
          {
            id: 2295,
            category_id: 736,
            media_id: 837,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%203.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%203.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 837,
              folder_id: 93,
              media_name: "G4 Image 3.jpg",
              media_url: "G4 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:40",
              updated_at: "2024-07-08 07:11:40",
            },
          },
          {
            id: 2296,
            category_id: 736,
            media_id: 840,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%204.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%204.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 840,
              folder_id: 93,
              media_name: "G4 Image 4.jpg",
              media_url: "G4 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:42",
              updated_at: "2024-07-08 07:11:42",
            },
          },
          {
            id: 2297,
            category_id: 736,
            media_id: 839,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%205.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%205.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 839,
              folder_id: 93,
              media_name: "G4 Image 5.jpg",
              media_url: "G4 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:41",
              updated_at: "2024-07-08 07:11:41",
            },
          },
          {
            id: 2298,
            category_id: 736,
            media_id: 834,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%206.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%206.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 834,
              folder_id: 93,
              media_name: "G4 Image 6.jpg",
              media_url: "G4 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:38",
              updated_at: "2024-07-08 07:11:38",
            },
          },
          {
            id: 2299,
            category_id: 736,
            media_id: 841,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%207.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%207.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 841,
              folder_id: 93,
              media_name: "G4 Image 7.jpg",
              media_url: "G4 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:43",
              updated_at: "2024-07-08 07:11:43",
            },
          },
          {
            id: 2300,
            category_id: 736,
            media_id: 843,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%208.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%208.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 843,
              folder_id: 93,
              media_name: "G4 Image 8.jpg",
              media_url: "G4 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:44",
              updated_at: "2024-07-08 07:11:44",
            },
          },
          {
            id: 2301,
            category_id: 736,
            media_id: 842,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%209.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%209.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 842,
              folder_id: 93,
              media_name: "G4 Image 9.jpg",
              media_url: "G4 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:43",
              updated_at: "2024-07-08 07:11:43",
            },
          },
          {
            id: 2302,
            category_id: 736,
            media_id: 836,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/thumb/G4%20Image%2010.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g4/G4%20Image%2010.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G4 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 836,
              folder_id: 93,
              media_name: "G4 Image 10.jpg",
              media_url: "G4 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:40",
              updated_at: "2024-07-08 07:11:40",
            },
          },
        ],
      },
      {
        id: 737,
        name: "SOUTH TOWER",
        parent_category: 731,
        child_category: [],
        media: [
          {
            id: 2304,
            category_id: 737,
            media_id: 864,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%202.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%202.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 864,
              folder_id: 96,
              media_name: "G5 Image 2.jpg",
              media_url: "G5 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:57",
              updated_at: "2024-07-08 07:11:57",
            },
          },
          {
            id: 2305,
            category_id: 737,
            media_id: 862,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%203.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%203.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 862,
              folder_id: 96,
              media_name: "G5 Image 3.jpg",
              media_url: "G5 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:55",
              updated_at: "2024-07-08 07:11:55",
            },
          },
          {
            id: 2306,
            category_id: 737,
            media_id: 868,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%204.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%204.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 868,
              folder_id: 96,
              media_name: "G5 Image 4.jpg",
              media_url: "G5 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:59",
              updated_at: "2024-07-08 07:11:59",
            },
          },
          {
            id: 2307,
            category_id: 737,
            media_id: 867,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%205.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%205.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 867,
              folder_id: 96,
              media_name: "G5 Image 5.jpg",
              media_url: "G5 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:59",
              updated_at: "2024-07-08 07:11:59",
            },
          },
          {
            id: 2308,
            category_id: 737,
            media_id: 866,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%206.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%206.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 866,
              folder_id: 96,
              media_name: "G5 Image 6.jpg",
              media_url: "G5 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:58",
              updated_at: "2024-07-08 07:11:58",
            },
          },
          {
            id: 2309,
            category_id: 737,
            media_id: 865,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%207.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%207.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 865,
              folder_id: 96,
              media_name: "G5 Image 7.jpg",
              media_url: "G5 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:57",
              updated_at: "2024-07-08 07:11:57",
            },
          },
          {
            id: 2310,
            category_id: 737,
            media_id: 863,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%208.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%208.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 863,
              folder_id: 96,
              media_name: "G5 Image 8.jpg",
              media_url: "G5 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:56",
              updated_at: "2024-07-08 07:11:56",
            },
          },
          {
            id: 2311,
            category_id: 737,
            media_id: 860,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%209.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%209.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 860,
              folder_id: 96,
              media_name: "G5 Image 9.jpg",
              media_url: "G5 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:54",
              updated_at: "2024-07-08 07:11:54",
            },
          },
          {
            id: 2312,
            category_id: 737,
            media_id: 859,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%2010.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%2010.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 859,
              folder_id: 96,
              media_name: "G5 Image 10.jpg",
              media_url: "G5 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:54",
              updated_at: "2024-07-08 07:11:54",
            },
          },
          {
            id: 2303,
            category_id: 737,
            media_id: 861,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/thumb/G5%20Image%201.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g5/G5%20Image%201.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G5 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 861,
              folder_id: 96,
              media_name: "G5 Image 1.jpg",
              media_url: "G5 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:55",
              updated_at: "2024-07-08 07:11:55",
            },
          },
        ],
      },
    ],
    get_exit_players: [],
  },
  {
    id: 732,
    name: "AMENITIES",
    category_image: "",
    primary_media: null,
    secondary_media: null,
    second_image: "no",
    parent_category: {
      id: 670,
      name: "GALLERY",
      category_image: "",
      primary_media: null,
      secondary_media: null,
      second_image: "no",
      parent_category: 660,
      hardware_id: null,
      instance_player: "",
      secondary_player: null,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "text",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
    hardware_id: 43,
    instance_player: null,
    secondary_player: "43",
    p_video_loop: "no",
    s_video_loop: "no",
    server_c_string: "000",
    exit_string: "000",
    site_status: "on",
    category_type: "text",
    category_order: 0,
    cross_fade: "yes",
    map_id: null,
    open_latitude: null,
    open_logitude: null,
    open_zoom: null,
    hide_overlay_text: 0,
    category_thumb: "",
    child_category: [
      {
        id: 738,
        name: "LOWER FLOOR",
        parent_category: 732,
        child_category: [],
        media: [
          {
            id: 2314,
            category_id: 738,
            media_id: 875,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 875,
              folder_id: 97,
              media_name: "G1 Image 1.jpg",
              media_url: "G1 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:04",
              updated_at: "2024-07-08 07:12:04",
            },
          },
          {
            id: 2315,
            category_id: 738,
            media_id: 872,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 872,
              folder_id: 97,
              media_name: "G1 Image 2.jpg",
              media_url: "G1 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:02",
              updated_at: "2024-07-08 07:12:02",
            },
          },
          {
            id: 2316,
            category_id: 738,
            media_id: 870,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 870,
              folder_id: 97,
              media_name: "G1 Image 3.jpg",
              media_url: "G1 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:00",
              updated_at: "2024-07-08 07:12:00",
            },
          },
          {
            id: 2317,
            category_id: 738,
            media_id: 874,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 874,
              folder_id: 97,
              media_name: "G1 Image 4.jpg",
              media_url: "G1 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:03",
              updated_at: "2024-07-08 07:12:03",
            },
          },
          {
            id: 2318,
            category_id: 738,
            media_id: 871,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 871,
              folder_id: 97,
              media_name: "G1 Image 5.jpg",
              media_url: "G1 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:01",
              updated_at: "2024-07-08 07:12:01",
            },
          },
          {
            id: 2319,
            category_id: 738,
            media_id: 877,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 877,
              folder_id: 97,
              media_name: "G1 Image 6.jpg",
              media_url: "G1 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:05",
              updated_at: "2024-07-08 07:12:05",
            },
          },
          {
            id: 2320,
            category_id: 738,
            media_id: 876,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 876,
              folder_id: 97,
              media_name: "G1 Image 7.jpg",
              media_url: "G1 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:04",
              updated_at: "2024-07-08 07:12:04",
            },
          },
          {
            id: 2321,
            category_id: 738,
            media_id: 869,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 869,
              folder_id: 97,
              media_name: "G1 Image 8.jpg",
              media_url: "G1 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:00",
              updated_at: "2024-07-08 07:12:00",
            },
          },
          {
            id: 2322,
            category_id: 738,
            media_id: 873,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 873,
              folder_id: 97,
              media_name: "G1 Image 9.jpg",
              media_url: "G1 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:03",
              updated_at: "2024-07-08 07:12:03",
            },
          },
          {
            id: 2323,
            category_id: 738,
            media_id: 878,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G1 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 878,
              folder_id: 97,
              media_name: "G1 Image 10.jpg",
              media_url: "G1 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:12:06",
              updated_at: "2024-07-08 07:12:06",
            },
          },
        ],
      },
      {
        id: 739,
        name: "GROUND FLOOR",
        parent_category: 732,
        child_category: [],
        media: [
          {
            id: 2324,
            category_id: 739,
            media_id: 828,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 828,
              folder_id: 84,
              media_name: "G2 Image 1.jpg",
              media_url: "G2 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:34",
              updated_at: "2024-07-08 07:11:34",
            },
          },
          {
            id: 2325,
            category_id: 739,
            media_id: 830,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 830,
              folder_id: 84,
              media_name: "G2 Image 2.jpg",
              media_url: "G2 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:36",
              updated_at: "2024-07-08 07:11:36",
            },
          },
          {
            id: 2326,
            category_id: 739,
            media_id: 824,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 824,
              folder_id: 84,
              media_name: "G2 Image 3.jpg",
              media_url: "G2 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:32",
              updated_at: "2024-07-08 07:11:32",
            },
          },
          {
            id: 2327,
            category_id: 739,
            media_id: 825,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 825,
              folder_id: 84,
              media_name: "G2 Image 4.jpg",
              media_url: "G2 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:33",
              updated_at: "2024-07-08 07:11:33",
            },
          },
          {
            id: 2328,
            category_id: 739,
            media_id: 832,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 832,
              folder_id: 84,
              media_name: "G2 Image 5.jpg",
              media_url: "G2 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:37",
              updated_at: "2024-07-08 07:11:37",
            },
          },
          {
            id: 2329,
            category_id: 739,
            media_id: 833,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 833,
              folder_id: 84,
              media_name: "G2 Image 6.jpg",
              media_url: "G2 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:38",
              updated_at: "2024-07-08 07:11:38",
            },
          },
          {
            id: 2330,
            category_id: 739,
            media_id: 827,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 827,
              folder_id: 84,
              media_name: "G2 Image 7.jpg",
              media_url: "G2 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:34",
              updated_at: "2024-07-08 07:11:34",
            },
          },
          {
            id: 2331,
            category_id: 739,
            media_id: 826,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 826,
              folder_id: 84,
              media_name: "G2 Image 8.jpg",
              media_url: "G2 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:33",
              updated_at: "2024-07-08 07:11:33",
            },
          },
          {
            id: 2332,
            category_id: 739,
            media_id: 829,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 829,
              folder_id: 84,
              media_name: "G2 Image 9.jpg",
              media_url: "G2 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:35",
              updated_at: "2024-07-08 07:11:35",
            },
          },
          {
            id: 2333,
            category_id: 739,
            media_id: 831,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G2 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 831,
              folder_id: 84,
              media_name: "G2 Image 10.jpg",
              media_url: "G2 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:36",
              updated_at: "2024-07-08 07:11:36",
            },
          },
        ],
      },
      {
        id: 740,
        name: "UPPER FLOOR",
        parent_category: 732,
        child_category: [],
        media: [
          {
            id: 2334,
            category_id: 740,
            media_id: 851,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%201.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%201.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 1.jpg",
            secondary_image: [],
            get_media: {
              id: 851,
              folder_id: 94,
              media_name: "G3 Image 1.jpg",
              media_url: "G3 Image 1.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:49",
              updated_at: "2024-07-08 07:11:49",
            },
          },
          {
            id: 2335,
            category_id: 740,
            media_id: 844,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%202.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%202.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 2.jpg",
            secondary_image: [],
            get_media: {
              id: 844,
              folder_id: 94,
              media_name: "G3 Image 2.jpg",
              media_url: "G3 Image 2.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:44",
              updated_at: "2024-07-08 07:11:44",
            },
          },
          {
            id: 2336,
            category_id: 740,
            media_id: 846,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%203.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%203.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 3.jpg",
            secondary_image: [],
            get_media: {
              id: 846,
              folder_id: 94,
              media_name: "G3 Image 3.jpg",
              media_url: "G3 Image 3.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:46",
              updated_at: "2024-07-08 07:11:46",
            },
          },
          {
            id: 2337,
            category_id: 740,
            media_id: 845,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%204.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%204.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 4.jpg",
            secondary_image: [],
            get_media: {
              id: 845,
              folder_id: 94,
              media_name: "G3 Image 4.jpg",
              media_url: "G3 Image 4.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:45",
              updated_at: "2024-07-08 07:11:45",
            },
          },
          {
            id: 2338,
            category_id: 740,
            media_id: 848,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 5.jpg",
            secondary_image: [],
            get_media: {
              id: 848,
              folder_id: 94,
              media_name: "G3 Image 5.jpg",
              media_url: "G3 Image 5.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:47",
              updated_at: "2024-07-08 07:11:47",
            },
          },
          {
            id: 2339,
            category_id: 740,
            media_id: 847,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%206.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%206.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 6.jpg",
            secondary_image: [],
            get_media: {
              id: 847,
              folder_id: 94,
              media_name: "G3 Image 6.jpg",
              media_url: "G3 Image 6.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:46",
              updated_at: "2024-07-08 07:11:46",
            },
          },
          {
            id: 2340,
            category_id: 740,
            media_id: 852,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%207.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%207.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 7.jpg",
            secondary_image: [],
            get_media: {
              id: 852,
              folder_id: 94,
              media_name: "G3 Image 7.jpg",
              media_url: "G3 Image 7.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:49",
              updated_at: "2024-07-08 07:11:49",
            },
          },
          {
            id: 2341,
            category_id: 740,
            media_id: 850,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/thumb/G3%20Image%208.jpg",
            image_name:
              "https://d2l284xife67k4.cloudfront.net/demo-images/g3/G3%20Image%208.jpg",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 8.jpg",
            secondary_image: [],
            get_media: {
              id: 850,
              folder_id: 94,
              media_name: "G3 Image 8.jpg",
              media_url: "G3 Image 8.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:48",
              updated_at: "2024-07-08 07:11:48",
            },
          },
          {
            id: 2342,
            category_id: 740,
            media_id: 849,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 9.jpg",
            secondary_image: [],
            get_media: {
              id: 849,
              folder_id: 94,
              media_name: "G3 Image 9.jpg",
              media_url: "G3 Image 9.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:47",
              updated_at: "2024-07-08 07:11:47",
            },
          },
          {
            id: 2343,
            category_id: 740,
            media_id: 853,
            parent_id: null,
            server_c_string: "000",
            deselect_string: "000",
            hardware_id: 43,
            gallery_type: "image",
            title: "",
            description: null,
            gallery_order: 0,
            thumb_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            image_name:
              "https://images.unsplash.com/photo-1718473476823-1ae4b63d6c7b?q=80&w=1651&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            hardware_details: {
              id: 43,
              name: "TheClarksonGallery",
              pin: "098127",
              refresh_action: null,
              screensaver_id: 27,
              start_time: "10",
              screensaver_time: "20",
              load_media_at_refresh: 0,
              screensaver_trigger: 0,
              refresh_time: "23:47:00",
              gallery_load_time: 2,
            },
            file_name: "G3 Image 10.jpg",
            secondary_image: [],
            get_media: {
              id: 853,
              folder_id: 94,
              media_name: "G3 Image 10.jpg",
              media_url: "G3 Image 10.jpg",
              media_type: "image",
              status: "active",
              created_at: "2024-07-08 07:11:50",
              updated_at: "2024-07-08 07:11:50",
            },
          },
        ],
      },
    ],
    get_exit_players: [],
  },
];

export const meetingFloorPlanData = {
  data: [
    {
      id: 1,
      unit: "2D",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "3",
      floor: "2",
      area: null,
      exterior_area: "370",
      common_charges: "4091",
      exposures: "S,W",
      price: 4250000,
      sqft_int: "2141",
      re_taxes: "3595",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 2,
      unit: "3A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "3",
      area: null,
      exterior_area: "",
      common_charges: "2890",
      exposures: "N,E,W",
      price: 2675000,
      sqft_int: "1570",
      re_taxes: "2540",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 3,
      unit: "3B",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "3",
      area: null,
      exterior_area: "",
      common_charges: "2382",
      exposures: "E",
      price: 2325000,
      sqft_int: "1294",
      re_taxes: "2093",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 4,
      unit: "3C",
      status_name: "AVAILABLE",
      bedrooms: "",
      bathrooms: "1",
      floor: "3",
      area: null,
      exterior_area: "",
      common_charges: "1285",
      exposures: "E",
      price: 1005000,
      sqft_int: "698",
      re_taxes: "1129",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 5,
      unit: "3D",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "3",
      area: null,
      exterior_area: "",
      common_charges: "3873",
      exposures: "S,W",
      price: 4100000,
      sqft_int: "2104",
      re_taxes: "3404",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 6,
      unit: "4A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "4",
      area: null,
      exterior_area: "",
      common_charges: "2904",
      exposures: "N,E,W",
      price: 2700000,
      sqft_int: "1570",
      re_taxes: "2553",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 7,
      unit: "4B",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "4",
      area: null,
      exterior_area: "",
      common_charges: "2394",
      exposures: "E",
      price: 2350000,
      sqft_int: "1294",
      re_taxes: "2104",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 8,
      unit: "4C",
      status_name: "AVAILABLE",
      bedrooms: "",
      bathrooms: "1",
      floor: "4",
      area: null,
      exterior_area: "",
      common_charges: "1291",
      exposures: "E",
      price: 1020000,
      sqft_int: "698",
      re_taxes: "1135",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 9,
      unit: "4D",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "4",
      area: null,
      exterior_area: "",
      common_charges: "3892",
      exposures: "S,W",
      price: 4150000,
      sqft_int: "2104",
      re_taxes: "3421",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 10,
      unit: "5A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "5",
      area: null,
      exterior_area: "",
      common_charges: "2919",
      exposures: "N,E,W",
      price: 2725000,
      sqft_int: "1570",
      re_taxes: "2565",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 11,
      unit: "5B",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "5",
      area: null,
      exterior_area: "",
      common_charges: "2406",
      exposures: "E",
      price: 2375000,
      sqft_int: "1294",
      re_taxes: "2114",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 12,
      unit: "5C",
      status_name: "AVAILABLE",
      bedrooms: "",
      bathrooms: "1",
      floor: "5",
      area: null,
      exterior_area: "",
      common_charges: "1298",
      exposures: "E",
      price: 1035000,
      sqft_int: "698",
      re_taxes: "1140",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 13,
      unit: "5D",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "5",
      area: null,
      exterior_area: "",
      common_charges: "3911",
      exposures: "S,W",
      price: 4200000,
      sqft_int: "2104",
      re_taxes: "3438",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 14,
      unit: "6A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "6",
      area: null,
      exterior_area: "",
      common_charges: "2933",
      exposures: "N,E,W",
      price: 2750000,
      sqft_int: "1570",
      re_taxes: "2578",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 15,
      unit: "6B",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "6",
      area: null,
      exterior_area: "",
      common_charges: "2406",
      exposures: "E",
      price: 2425000,
      sqft_int: "1288",
      re_taxes: "2115",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 16,
      unit: "6C",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "6",
      area: null,
      exterior_area: "868",
      common_charges: "3389",
      exposures: "E,W",
      price: 3025000,
      sqft_int: "1597",
      re_taxes: "2978",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 17,
      unit: "7A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "7",
      area: null,
      exterior_area: "",
      common_charges: "2947",
      exposures: "N,E,W",
      price: 2805000,
      sqft_int: "1570",
      re_taxes: "2590",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 18,
      unit: "7B",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "7",
      area: null,
      exterior_area: "",
      common_charges: "2418",
      exposures: "E",
      price: 2450000,
      sqft_int: "1288",
      re_taxes: "2125",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 19,
      unit: "7C",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "7",
      area: null,
      exterior_area: "",
      common_charges: "2998",
      exposures: "E,W",
      price: 2625000,
      sqft_int: "1597",
      re_taxes: "2635",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 20,
      unit: "8A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "8",
      area: null,
      exterior_area: "",
      common_charges: "2962",
      exposures: "N,E,W",
      price: 2855000,
      sqft_int: "1570",
      re_taxes: "2603",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 21,
      unit: "8B",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "8",
      area: null,
      exterior_area: "",
      common_charges: "2430",
      exposures: "E",
      price: 2475000,
      sqft_int: "1288",
      re_taxes: "2135",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 22,
      unit: "8C",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "8",
      area: null,
      exterior_area: "",
      common_charges: "3013",
      exposures: "E,W",
      price: 2675000,
      sqft_int: "1597",
      re_taxes: "2648",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 23,
      unit: "9A",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "9",
      area: null,
      exterior_area: "475",
      common_charges: "3383",
      exposures: "E,W",
      price: 4250000,
      sqft_int: "1666",
      re_taxes: "2973",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 24,
      unit: "9B",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "9",
      area: null,
      exterior_area: "475",
      common_charges: "3415",
      exposures: "E,W",
      price: 4150000,
      sqft_int: "1683",
      re_taxes: "3002",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 25,
      unit: "10A",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "10",
      area: null,
      exterior_area: "",
      common_charges: "1514",
      exposures: "N,W",
      price: 1750000,
      sqft_int: "795",
      re_taxes: "1331",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 26,
      unit: "10B",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "10",
      area: null,
      exterior_area: "",
      common_charges: "1558",
      exposures: "E",
      price: 1700000,
      sqft_int: "818",
      re_taxes: "1369",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 27,
      unit: "10C",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "10",
      area: null,
      exterior_area: "",
      common_charges: "1558",
      exposures: "E",
      price: 1700000,
      sqft_int: "818",
      re_taxes: "1369",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 28,
      unit: "10D",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "10",
      area: null,
      exterior_area: "",
      common_charges: "1512",
      exposures: "W",
      price: 1750000,
      sqft_int: "794",
      re_taxes: "1329",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 29,
      unit: "11A",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "11",
      area: null,
      exterior_area: "65",
      common_charges: "1553",
      exposures: "W",
      price: 1800000,
      sqft_int: "795",
      re_taxes: "1365",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 30,
      unit: "11B",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "11",
      area: null,
      exterior_area: "",
      common_charges: "1566",
      exposures: "E",
      price: 1715000,
      sqft_int: "818",
      re_taxes: "1376",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 31,
      unit: "11C",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "11",
      area: null,
      exterior_area: "",
      common_charges: "1566",
      exposures: "E",
      price: 1715000,
      sqft_int: "818",
      re_taxes: "1376",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 32,
      unit: "11D",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "11",
      area: null,
      exterior_area: "65",
      common_charges: "1151",
      exposures: "W",
      price: 1800000,
      sqft_int: "794",
      re_taxes: "1363",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 33,
      unit: "12A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "12",
      area: null,
      exterior_area: "",
      common_charges: "2419",
      exposures: "E,W",
      price: 2525000,
      sqft_int: "1258",
      re_taxes: "2126",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 34,
      unit: "12B",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "12",
      area: null,
      exterior_area: "",
      common_charges: "1592",
      exposures: "E",
      price: 1730000,
      sqft_int: "828",
      re_taxes: "1399",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 35,
      unit: "12C",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "12",
      area: null,
      exterior_area: "",
      common_charges: "2419",
      exposures: "E,S,W",
      price: 2675000,
      sqft_int: "1258",
      re_taxes: "2126",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 36,
      unit: "13B",
      status_name: "UNAVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "13",
      area: null,
      exterior_area: "",
      common_charges: "",
      exposures: "",
      price: 0,
      sqft_int: "828",
      re_taxes: "",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 37,
      unit: "14A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "14",
      area: null,
      exterior_area: "",
      common_charges: "2442",
      exposures: "E,W",
      price: 2550000,
      sqft_int: "1258",
      re_taxes: "2147",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 38,
      unit: "14B",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "14",
      area: null,
      exterior_area: "",
      common_charges: "1608",
      exposures: "E",
      price: 1745000,
      sqft_int: "828",
      re_taxes: "1413",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 39,
      unit: "14C",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "14",
      area: null,
      exterior_area: "",
      common_charges: "2442",
      exposures: "E,S,W",
      price: 2700000,
      sqft_int: "1258",
      re_taxes: "2147",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 40,
      unit: "15A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "15",
      area: null,
      exterior_area: "65",
      common_charges: "2486",
      exposures: "N,E,W",
      price: 2625000,
      sqft_int: "1258",
      re_taxes: "2184",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 41,
      unit: "15B",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "15",
      area: null,
      exterior_area: "",
      common_charges: "1615",
      exposures: "E",
      price: 1760000,
      sqft_int: "828",
      re_taxes: "1419",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 42,
      unit: "15C",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "15",
      area: null,
      exterior_area: "65",
      common_charges: "2486",
      exposures: "E,S,W",
      price: 2780000,
      sqft_int: "1258",
      re_taxes: "2184",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 43,
      unit: "16A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "16",
      area: null,
      exterior_area: "91",
      common_charges: "2510",
      exposures: "N,E,W",
      price: 2675000,
      sqft_int: "1258",
      re_taxes: "2206",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 44,
      unit: "16B",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "16",
      area: null,
      exterior_area: "",
      common_charges: "1623",
      exposures: "E",
      price: 1775000,
      sqft_int: "828",
      re_taxes: "1426",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 45,
      unit: "16C",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "16",
      area: null,
      exterior_area: "91",
      common_charges: "2510",
      exposures: "E,S,W",
      price: 2805000,
      sqft_int: "1258",
      re_taxes: "2206",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 46,
      unit: "17A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "17",
      area: null,
      exterior_area: "",
      common_charges: "2477",
      exposures: "N,E,W",
      price: 2700000,
      sqft_int: "1258",
      re_taxes: "2177",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 47,
      unit: "17B",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "17",
      area: null,
      exterior_area: "",
      common_charges: "1630",
      exposures: "E",
      price: 1825000,
      sqft_int: "828",
      re_taxes: "1433",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 48,
      unit: "17C",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "17",
      area: null,
      exterior_area: "",
      common_charges: "2477",
      exposures: "E,S,W",
      price: 2830000,
      sqft_int: "1258",
      re_taxes: "2177",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 49,
      unit: "18A",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "18",
      area: null,
      exterior_area: "65",
      common_charges: "2521",
      exposures: "N,E,W",
      price: 2780000,
      sqft_int: "1258",
      re_taxes: "2215",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 50,
      unit: "18B",
      status_name: "AVAILABLE",
      bedrooms: "1",
      bathrooms: "1",
      floor: "18",
      area: null,
      exterior_area: "",
      common_charges: "1638",
      exposures: "E",
      price: 1850000,
      sqft_int: "828",
      re_taxes: "1439",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 51,
      unit: "18C",
      status_name: "AVAILABLE",
      bedrooms: "2",
      bathrooms: "2",
      floor: "18",
      area: null,
      exterior_area: "65",
      common_charges: "2521",
      exposures: "E,S,W",
      price: 2905000,
      sqft_int: "1258",
      re_taxes: "2215",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 52,
      unit: "19A",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "19",
      area: null,
      exterior_area: "91",
      common_charges: "3386",
      exposures: "N,E,W",
      price: 4200000,
      sqft_int: "1681",
      re_taxes: "2976",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 53,
      unit: "19B",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "19",
      area: null,
      exterior_area: "91",
      common_charges: "3410",
      exposures: "E,S,W",
      price: 3975000,
      sqft_int: "1693",
      re_taxes: "2997",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 54,
      unit: "20A",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "20",
      area: null,
      exterior_area: "",
      common_charges: "3356",
      exposures: "N,E,W",
      price: 4125000,
      sqft_int: "1681",
      re_taxes: "2949",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 55,
      unit: "20B",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "20",
      area: null,
      exterior_area: "",
      common_charges: "3380",
      exposures: "E,S,W",
      price: 3950000,
      sqft_int: "1693",
      re_taxes: "2971",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 56,
      unit: "21A",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "21",
      area: null,
      exterior_area: "65",
      common_charges: "3404",
      exposures: "N,E,W",
      price: 4275000,
      sqft_int: "1681",
      re_taxes: "2992",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 57,
      unit: "21B",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "21",
      area: null,
      exterior_area: "65",
      common_charges: "3428",
      exposures: "E,S,W",
      price: 4050000,
      sqft_int: "1693",
      re_taxes: "3013",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 58,
      unit: "22A",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "22",
      area: null,
      exterior_area: "91",
      common_charges: "3433",
      exposures: "N,E,W",
      price: 4325000,
      sqft_int: "1681",
      re_taxes: "3017",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 59,
      unit: "22B",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "22",
      area: null,
      exterior_area: "91",
      common_charges: "3457",
      exposures: "E,S,W",
      price: 4075000,
      sqft_int: "1693",
      re_taxes: "3038",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 60,
      unit: "23A",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "23",
      area: null,
      exterior_area: "",
      common_charges: "3402",
      exposures: "N,E,W",
      price: 4200000,
      sqft_int: "1681",
      re_taxes: "2990",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 61,
      unit: "23B",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "23",
      area: null,
      exterior_area: "",
      common_charges: "3426",
      exposures: "E,S,W",
      price: 4025000,
      sqft_int: "1693",
      re_taxes: "3011",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 62,
      unit: "24A",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "24",
      area: null,
      exterior_area: "65",
      common_charges: "3451",
      exposures: "N,E,W",
      price: 4400000,
      sqft_int: "1681",
      re_taxes: "3033",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 63,
      unit: "24B",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "24",
      area: null,
      exterior_area: "65",
      common_charges: "3475",
      exposures: "E,S,W",
      price: 4150000,
      sqft_int: "1693",
      re_taxes: "3054",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 64,
      unit: "25A",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "25",
      area: null,
      exterior_area: "91",
      common_charges: "3479",
      exposures: "N,E,W",
      price: 4450000,
      sqft_int: "1681",
      re_taxes: "3058",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 65,
      unit: "25B",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "25",
      area: null,
      exterior_area: "91",
      common_charges: "3504",
      exposures: "E,S,W",
      price: 4200000,
      sqft_int: "1693",
      re_taxes: "3079",
      half_bathroom: "",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
    {
      id: 66,
      unit: "PH",
      status_name: "AVAILABLE",
      bedrooms: "3",
      bathrooms: "3",
      floor: "25",
      area: null,
      exterior_area: "580",
      common_charges: "6219",
      exposures: "N,S,E,W",
      price: 0,
      sqft_int: "2899",
      re_taxes: "5466",
      half_bathroom: "1",
      server_c_string_selected: null,
      server_c_string_deselected: null,
      category_id: {
        id: 704,
        name: "FLOORPLANS",
        category_image: "",
        primary_media: null,
        secondary_media: null,
        second_image: "no",
        parent_category: 663,
        hardware_id: 43,
        instance_player: "",
        secondary_player: 43,
        p_video_loop: "no",
        s_video_loop: "no",
        server_c_string: "000",
        exit_string: "000",
        site_status: "on",
        category_type: "property",
        category_order: 0,
        cross_fade: "yes",
        map_id: null,
        open_latitude: null,
        open_logitude: null,
        open_zoom: null,
        hide_overlay_text: 0,
        get_instance_player: null,
      },
    },
  ],
  filter_values: {
    sortData: [
      "idx",
      "unit",
      "status_name",
      "bedrooms",
      "bathrooms",
      "floor",
      "area",
      "area_m",
      "exterior_area",
      "exterior_area_m",
      "monthly_common_charges",
      "monthly_real_estate_taxes",
      "exposures",
      "price",
      "powder",
      "kitchen",
      "sqft_int",
      "re_taxes",
      "half_bathroom",
      "orientation",
      "hide_overlay_text",
      "cl_height",
    ],
    price: {
      max_price: 4450000,
      min_price: 0,
      max_sq_ft: 2899,
      min_sq_ft: 698,
    },
    bedrooms: ["", "1", "2", "3"],
    baths: ["1", "2", "3"],
    building: [],
    avaliable: ["AVAILABLE", "UNAVAILABLE"],
    view: [
      "",
      "E",
      "E",
      "S",
      "W",
      "E",
      "W",
      "N",
      "E",
      "W",
      "N",
      "S",
      "E",
      "W",
      "N",
      "W",
      "S",
      "W",
      "W",
    ],
    categoryInfo: {
      id: 704,
      name: "FLOORPLANS",
      category_image: "",
      primary_media: null,
      secondary_media: null,
      second_image: "no",
      parent_category: 663,
      hardware_id: 43,
      instance_player: "",
      secondary_player: 43,
      p_video_loop: "no",
      s_video_loop: "no",
      server_c_string: "000",
      exit_string: "000",
      site_status: "on",
      category_type: "property",
      category_order: 0,
      cross_fade: "yes",
      map_id: null,
      open_latitude: null,
      open_logitude: null,
      open_zoom: null,
      hide_overlay_text: 0,
      get_instance_player: null,
    },
  },
};

export const propertyImagesData = {
  data: [
    {
      id: 501,
      title: "FP 1",
      description: "FP Description",
      player_name: "TheClarksonGallery",
      server_c_string: "000",
      exit_string: "000",
      hardware_id: 43,
      type: "floor_plan",
      is_default: "yes",
      view_image: "no",
      thumb_url:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      image_name:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      file_name: "Floor Plan 1.jpg",
    },
    {
      id: 567,
      title: "Render 1",
      description: "Render 1 Description",
      player_name: "TheClarksonGallery",
      server_c_string: "000",
      exit_string: "000",
      hardware_id: 43,
      type: "rendering",
      is_default: "no",
      view_image: "no",
      thumb_url:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      image_name:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      file_name: "G5 Image 1.jpg",
    },
    {
      id: 633,
      title: "Render 2",
      description: "Render 2 Description",
      player_name: "TheClarksonGallery",
      server_c_string: "000",
      exit_string: "000",
      hardware_id: 43,
      type: "rendering",
      is_default: "no",
      view_image: "no",
      thumb_url:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      image_name:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      file_name: "G5 Image 2.jpg",
    },
    {
      id: 699,
      title: "Render 3",
      description: "Render 3 Description",
      player_name: "TheClarksonGallery",
      server_c_string: "000",
      exit_string: "000",
      hardware_id: 43,
      type: "rendering",
      is_default: "no",
      view_image: "no",
      thumb_url:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      image_name:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      file_name: "G5 Image 3.jpg",
    },
    {
      id: 765,
      title: "View 1",
      description: "View 1 Description",
      player_name: "TheClarksonGallery",
      server_c_string: "000",
      exit_string: "000",
      hardware_id: 43,
      type: "view",
      is_default: "no",
      view_image: "no",
      thumb_url:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      image_name:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      file_name: "G5 Image 4.jpg",
    },
    {
      id: 831,
      title: "View 2",
      description: "View 2 Description",
      player_name: "TheClarksonGallery",
      server_c_string: "000",
      exit_string: "000",
      hardware_id: 43,
      type: "view",
      is_default: "no",
      view_image: "no",
      thumb_url:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      image_name:
        "https://plus.unsplash.com/premium_photo-1672423154405-5fd922c11af2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      file_name: "G5 Image 5.jpg",
    },
  ],
  ar_data: [],
  hide_overlay_text: 0,
};

export const filterOptionsName = {
  bedrooms: {
    title: "Bedroom Count",
    valueText: "Bedroom",
    filterKey: "bedrooms",
  },
  baths: {
    title: "Bathroom Count",
    valueText: "Bath",
    filterKey: "bathrooms",
  },
};
